msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-11 15:05+0000\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: file.name
#: src/components/chat/ChatComposer.tsx:1258
msgid "'{0}' exceeds the {FILE_SIZE_LIMIT_LABEL} attachment limit."
msgstr "'{0}' exceeds the {FILE_SIZE_LIMIT_LABEL} attachment limit."

#. placeholder {0}: file.name
#: src/components/chat/ChatComposer.tsx:1286
msgid "'{0}' exceeds the {IMAGE_SIZE_LIMIT_LABEL} image preview limit and will be stored as a file."
msgstr "'{0}' exceeds the {IMAGE_SIZE_LIMIT_LABEL} image preview limit and will be stored as a file."

#: src/components/chat/MessagesTimeline.tsx:412
msgid "(empty response)"
msgstr "(empty response)"

#. placeholder {0}: rows.length + (isAddingBinding ? 1 : 0)
#: src/components/settings/KeybindingsSettings.tsx:1199
msgid "{0, plural, one {# binding} other {# bindings}}"
msgstr "{0, plural, one {# binding} other {# bindings}}"

#. placeholder {0}: scopes.length
#: src/components/settings/ConnectionsSettings.tsx:142
msgid "{0, plural, one {# scope} other {# scopes}}"
msgstr "{0, plural, one {# scope} other {# scopes}}"

#. placeholder {0}: attachments.length
#: src/components/chat/AttachmentsBlock.tsx:68
#~ msgid "{0, plural, one {Attached file} other {Attached files}}"
#~ msgstr "{0, plural, one {Attached file} other {Attached files}}"

#. placeholder {0}: latestProjectThreads.length
#. placeholder {1}: member.name
#. placeholder {2}: member.name
#: src/components/Sidebar.tsx:1108
msgid "{0, plural, one {Remove project \"{1}\" and delete its # thread?} other {Remove project \"{2}\" and delete its # threads?}}"
msgstr "{0, plural, one {Remove project \"{1}\" and delete its # thread?} other {Remove project \"{2}\" and delete its # threads?}}"

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:375
msgid "{0} documents deleted"
msgstr "{0} documents deleted"

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:455
msgid "{0} files added to materials"
msgstr "{0} files added to materials"

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:414
msgid "{0} files deleted"
msgstr "{0} files deleted"

#. placeholder {0}: errorMessageFromUnknown(error)
#: src/components/auth/PairingRouteSurface.tsx:206
msgid "{0} If the backend accepted this one-time token, request a new pairing link before retrying."
msgstr "{0} If the backend accepted this one-time token, request a new pairing link before retrying."

#. placeholder {0}: activeEnvironmentUnavailableState.label
#. placeholder {0}: environmentUnavailable.label
#: src/components/chat/ChatComposer.tsx:1618
#: src/components/ChatView.tsx:550
msgid "{0} is connecting"
msgstr "{0} is connecting"

#. placeholder {0}: activeEnvironmentUnavailableState.label
#. placeholder {0}: environmentUnavailable.label
#: src/components/chat/ChatComposer.tsx:1619
#: src/components/ChatView.tsx:552
msgid "{0} is disconnected"
msgstr "{0} is disconnected"

#. placeholder {0}: record.label
#: src/components/settings/ConnectionsSettings.tsx:1385
msgid "{0} is now saved and will reconnect on app startup."
msgstr "{0} is now saved and will reconnect on app startup."

#. placeholder {0}: record.label
#: src/components/auth/PairingRouteSurface.tsx:200
msgid "{0} is saved in this browser."
msgstr "{0} is saved in this browser."

#. placeholder {0}: skill.scope
#: src/components/chat/ChatComposer.tsx:575
msgid "{0} skill"
msgstr "{0} skill"

#: src/components/settings/KeybindingsSettings.tsx:252
msgid "{APP_BASE_NAME} does not recognize this condition yet. It can still be saved, but it may not match unless the runtime provides it."
msgstr "{APP_BASE_NAME} does not recognize this condition yet. It can still be saved, but it may not match unless the runtime provides it."

#: src/components/SplashScreen.tsx:11
msgid "{APP_BASE_NAME} splash screen"
msgstr "{APP_BASE_NAME} splash screen"

#: src/components/WebSocketConnectionSurface.tsx:91
msgid "{count, plural, one {# request waiting longer than {thresholdSeconds}s.} other {# requests waiting longer than {thresholdSeconds}s.}}"
msgstr "{count, plural, one {# request waiting longer than {thresholdSeconds}s.} other {# requests waiting longer than {thresholdSeconds}s.}}"

#: src/components/Sidebar.tsx:1284
msgid "{count, plural, one {Delete # thread?} other {Delete # threads?}}"
msgstr "{count, plural, one {Delete # thread?} other {Delete # threads?}}"

#: src/components/settings/ConnectionsSettings.tsx:1018
msgid "{days, plural, one {# day} other {# days}}"
msgstr "{days, plural, one {# day} other {# days}}"

#: src/timestampFormat.ts:69
#: src/timestampFormat.ts:96
#: src/timestampFormat.ts:113
#: src/timestampFormat.ts:149
msgid "{days}d"
msgstr "{days}d"

#: src/components/ChatView.tsx:530
msgid "{environmentLabel} server"
msgstr "{environmentLabel} server"

#: src/components/DocumentsSidebar.tsx:702
msgid "{failed, plural, one {# error} other {# errors}}"
msgstr "{failed, plural, one {# error} other {# errors}}"

#: src/components/chat/MessagesTimeline.tsx:878
#: src/components/chat/MessagesTimeline.tsx:878
#: src/timestampFormat.ts:67
#: src/timestampFormat.ts:93
#: src/timestampFormat.ts:111
#: src/timestampFormat.ts:150
msgid "{hours}h"
msgstr "{hours}h"

#: src/components/settings/DiagnosticsSettings.tsx:100
msgid "{label} details"
msgstr "{label} details"

#: src/components/ChatView.tsx:456
msgid "{label} is ready."
msgstr "{label} is ready."

#: src/components/settings/ConnectionsSettings.tsx:153
msgid "{label}: show {scopeCountLabel}"
msgstr "{label}: show {scopeCountLabel}"

#: src/components/settings/ConnectionsSettings.tsx:492
msgid "{lastUsedElapsed} ago"
msgstr "{lastUsedElapsed} ago"

#: src/components/settings/ConnectionsSettings.tsx:967
msgid "{maxUses, plural, one {# device} other {# devices}}"
msgstr "{maxUses, plural, one {# device} other {# devices}}"

#: src/session-logic.ts:128
#: src/session-logic.ts:132
msgid "{milliseconds}ms"
msgstr "{milliseconds}ms"

#: src/components/chat/MessagesTimeline.tsx:878
#: src/components/chat/MessagesTimeline.tsx:881
#: src/components/chat/MessagesTimeline.tsx:881
#: src/session-logic.ts:145
#: src/session-logic.ts:146
#: src/session-logic.ts:158
#: src/timestampFormat.ts:65
#: src/timestampFormat.ts:90
#: src/timestampFormat.ts:109
#: src/timestampFormat.ts:151
msgid "{minutes}m"
msgstr "{minutes}m"

#: src/session-logic.ts:158
#~ msgid "{padded}s"
#~ msgstr "{padded}s"

#: src/components/DocumentsSidebar.tsx:698
msgid "{pages, plural, one {# page} other {# pages}}"
msgstr "{pages, plural, one {# page} other {# pages}}"

#: src/components/settings/ConnectionsSettings.tsx:961
msgid "{pairingMaxUses, plural, one {# device} other {# devices}}"
msgstr "{pairingMaxUses, plural, one {# device} other {# devices}}"

#: src/components/settings/ConnectionsSettings.tsx:978
msgid "{pairingMaxUses, plural, one {The link stops working after # device has paired with it.} other {The link stops working after # devices have paired with it.}}"
msgstr "{pairingMaxUses, plural, one {The link stops working after # device has paired with it.} other {The link stops working after # devices have paired with it.}}"

#: src/components/settings/ConnectionsSettings.tsx:1009
msgid "{pairingTtlDays, plural, one {# day} other {# days}}"
msgstr "{pairingTtlDays, plural, one {# day} other {# days}}"

#: src/components/DocumentsSidebar.tsx:700
msgid "{pending} pending"
msgstr "{pending} pending"

#: src/components/chat/MessagesTimeline.tsx:691
msgid "{runningAgents, plural, one {# agent working} other {# agents working}}"
msgstr "{runningAgents, plural, one {# agent working} other {# agents working}}"

#: src/components/chat/MessagesTimeline.tsx:870
#: src/components/chat/MessagesTimeline.tsx:881
#: src/components/chat/MessagesTimeline.tsx:886
#: src/components/WebSocketConnectionSurface.tsx:42
#: src/session-logic.ts:137
#: src/session-logic.ts:146
#: src/session-logic.ts:155
#: src/session-logic.ts:158
#: src/timestampFormat.ts:87
#: src/timestampFormat.ts:107
#: src/timestampFormat.ts:152
#: src/timestampFormat.ts:153
msgid "{seconds}s"
msgstr "{seconds}s"

#: src/components/DocumentsSidebar.tsx:832
msgid "{selectedCount} selected"
msgstr "{selectedCount} selected"

#: src/components/chat/MessagesTimeline.tsx:457
#~ msgid "{stageCount, plural, one {# stage} other {# stages}}"
#~ msgstr "{stageCount, plural, one {# stage} other {# stages}}"

#: src/components/DocumentsSidebar.tsx:696
msgid "{total, plural, one {# document} other {# documents}}"
msgstr "{total, plural, one {# document} other {# documents}}"

#: src/components/settings/ConnectionsSettings.tsx:504
msgid "{useCountLabel} · {lastUsedLabel}"
msgstr "{useCountLabel} · {lastUsedLabel}"

#: src/components/chat/AttachmentsBlock.tsx:106
msgid "+{hiddenCount} more"
msgstr "+{hiddenCount} more"

#: src/components/chat/MessagesTimeline.tsx:1152
#~ msgid "× {count}"
#~ msgstr "× {count}"

#: src/components/settings/SettingsPanels.tsx:61
msgid "12-hour"
msgstr "12-hour"

#: src/components/settings/SettingsPanels.tsx:62
msgid "24-hour"
msgstr "24-hour"

#: src/components/settings/ConnectionsSettings.tsx:525
msgid "A client paired with this link is connected now"
msgstr "A client paired with this link is connected now"

#: src/components/settings/SettingsPanels.tsx:385
msgid "About"
msgstr "About"

#: src/components/CommandPalette.logic.ts:257
msgid "Actions"
msgstr "Actions"

#. placeholder {0}: commandLabel(row.command)
#. placeholder {0}: project.displayName
#. placeholder {0}: thread.title
#: src/components/settings/KeybindingsSettings.tsx:912
#: src/components/Sidebar.tsx:456
#: src/components/Sidebar.tsx:1764
msgid "Actions for {0}"
msgstr "Actions for {0}"

#: src/components/chat/DraftProjectChip.tsx:157
msgid "Add a project to start a chat."
msgstr "Add a project to start a chat."

#: src/components/settings/ConnectionsSettings.tsx:1601
#: src/components/settings/ConnectionsSettings.tsx:1717
#: src/components/settings/ConnectionsSettings.tsx:1721
#: src/components/settings/ConnectionsSettings.tsx:1729
#: src/routes/_chat.index.tsx:80
msgid "Add environment"
msgstr "Add environment"

#: src/components/settings/ConnectionsSettings.tsx:1735
msgid "Add Environment"
msgstr "Add Environment"

#: src/components/settings/KeybindingsSettings.tsx:1226
#: src/components/settings/KeybindingsSettings.tsx:1233
msgid "Add keybinding"
msgstr "Add keybinding"

#: src/components/CommandPalette.tsx:304
msgid "add project"
msgstr "add project"

#: src/components/AddSafeProjectDialog.tsx:168
#: src/components/CommandPalette.tsx:308
msgid "Add project"
msgstr "Add project"

#: src/components/DocumentsSidebar.tsx:660
#: src/components/DocumentsSidebar.tsx:847
msgid "Add to materials"
msgstr "Add to materials"

#. placeholder {0}: fileBasename(files[0]!.path)
#: src/components/DocumentsSidebar.tsx:454
msgid "Added to materials: {0}"
msgstr "Added to materials: {0}"

#: src/components/AddSafeProjectDialog.tsx:168
#: src/components/settings/ConnectionsSettings.tsx:1601
msgid "Adding…"
msgstr "Adding…"

#: src/components/settings/ConnectionsSettings.tsx:1690
msgid "Administrative access"
msgstr "Administrative access"

#: src/components/Sidebar.tsx:1632
msgid "Administrator block"
msgstr "Administrator block"

#: src/components/settings/InspectSettings.tsx:21
#~ msgid "Administrator view"
#~ msgstr "Administrator view"

#: src/components/settings/CapabilitiesSettings.tsx:207
#: src/components/settings/DiagnosticsSettings.tsx:304
msgid "Agent"
msgstr "Agent"

#: src/components/SubAgentPanel.tsx:46
msgid "Agent task"
msgstr "Agent task"

#: src/components/chat/SubAgentsHeaderButton.tsx:24
#: src/components/SubAgentPanel.tsx:85
msgid "Agents"
msgstr "Agents"

#: src/timestampFormat.ts:65
#: src/timestampFormat.ts:67
#: src/timestampFormat.ts:69
msgid "ago"
msgstr "ago"

#: src/hooks/useVoiceInput.ts:126
msgid "Allow the microphone for this site in the browser settings, then press the microphone again."
msgstr "Allow the microphone for this site in the browser settings, then press the microphone again."

#: src/components/settings/KeybindingsSettings.tsx:673
#: src/components/settings/KeybindingsSettings.tsx:887
#: src/components/settings/KeybindingsSettings.tsx:1049
msgid "Always"
msgstr "Always"

#: src/components/AddSafeProjectDialog.tsx:131
#: src/components/DocumentsSidebar.tsx:294
#: src/components/settings/SettingsPanels.tsx:478
#: src/components/settings/SettingsPanels.tsx:562
#: src/components/Sidebar.tsx:756
#: src/components/Sidebar.tsx:776
#: src/components/Sidebar.tsx:796
#: src/components/Sidebar.tsx:1443
#: src/components/Sidebar.tsx:1497
#: src/components/Sidebar.tsx:1555
#: src/components/Sidebar.tsx:1642
msgid "An error occurred."
msgstr "An error occurred."

#: src/components/CommandPalette.tsx:364
msgid "An unexpected error occurred."
msgstr "An unexpected error occurred."

#: src/routes/__root.tsx:236
msgid "An unexpected router error occurred."
msgstr "An unexpected router error occurred."

#: src/components/settings/ConnectionsSettings.tsx:251
msgid "An unknown connection error occurred."
msgstr "An unknown connection error occurred."

#: src/components/chat/MessagesTimeline.tsx:1182
msgid "and {more} more"
msgstr "and {more} more"

#: src/components/settings/ConnectionsSettings.tsx:960
#: src/components/settings/ConnectionsSettings.tsx:971
msgid "Any number of devices"
msgstr "Any number of devices"

#: src/components/chat/MessagesTimeline.tsx:946
msgid "Approval resolved"
msgstr "Approval resolved"

#: src/components/settings/DiagnosticsSettings.tsx:1019
msgid "Approximate active CPU time for the T3 server root process and its descendants during the selected window. It grows only while sampled processes use CPU and older samples leave as the window moves."
msgstr "Approximate active CPU time for the T3 server root process and its descendants during the selected window. It grows only while sampled processes use CPU and older samples leave as the window moves."

#: src/components/settings/settingsNavItems.ts:47
#: src/components/Sidebar.tsx:1588
msgid "Archive"
msgstr "Archive"

#: src/components/settings/SettingsPanels.tsx:336
msgid "archive confirmation"
msgstr "archive confirmation"

#: src/components/settings/SettingsPanels.tsx:139
#: src/components/settings/SettingsPanels.tsx:331
msgid "Archive confirmation"
msgstr "Archive confirmation"

#. placeholder {0}: thread.title
#: src/components/Sidebar.tsx:1650
msgid "Archive thread \"{0}\"?"
msgstr "Archive thread \"{0}\"?"

#. placeholder {0}: formatRelativeTimeLabel(thread.archivedAt ?? thread.createdAt)
#. placeholder {1}: formatRelativeTimeLabel(thread.createdAt)
#: src/components/settings/SettingsPanels.tsx:541
msgid "Archived {0} · Created {1}"
msgstr "Archived {0} · Created {1}"

#: src/components/settings/SettingsPanels.tsx:496
msgid "Archived threads"
msgstr "Archived threads"

#: src/components/settings/SettingsPanels.tsx:515
msgid "Archived threads will appear here."
msgstr "Archived threads will appear here."

#: src/components/chat/MessagesTimeline.tsx:1501
msgid "Arguments"
msgstr "Arguments"

#: src/components/settings/SettingsPanels.tsx:358
msgid "Ask before deleting a thread and its chat history."
msgstr "Ask before deleting a thread and its chat history."

#: src/components/chat/ChatComposer.tsx:227
#: src/components/chat/ChatComposer.tsx:233
msgid "Attach files"
msgstr "Attach files"

#: src/components/DocumentsSidebar.tsx:738
msgid "Attach files in the chat to add them."
msgstr "Attach files in the chat to add them."

#. placeholder {0}: status.reconnectMaxAttempts
#: src/components/WebSocketConnectionSurface.tsx:50
msgid "Attempt {reconnectAttempt}/{0}"
msgstr "Attempt {reconnectAttempt}/{0}"

#: src/components/auth/PairingRouteSurface.tsx:293
msgid "Authentication failed."
msgstr "Authentication failed."

#: src/environments/primary/auth.ts:188
msgid "Authentication required."
msgstr "Authentication required."

#: src/components/settings/ConnectionsSettings.tsx:1680
msgid "Authorized clients"
msgstr "Authorized clients"

#: src/components/settings/SettingsPanels.tsx:310
msgid "auto-open task panel"
msgstr "auto-open task panel"

#: src/components/settings/SettingsPanels.tsx:136
#: src/components/settings/SettingsPanels.tsx:305
msgid "Auto-open task panel"
msgstr "Auto-open task panel"

#: src/components/Sidebar.tsx:1747
msgid "Available in multiple environments"
msgstr "Available in multiple environments"

#: src/components/settings/DiagnosticsSettings.tsx:724
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Average"
msgstr "Average"

#. placeholder {0}: bucket.avgCpuPercent.toFixed(1)
#. placeholder {1}: bucket.maxCpuPercent.toFixed(1)
#: src/components/settings/DiagnosticsSettings.tsx:629
msgid "Average CPU {0}%, peak CPU {1}%"
msgstr "Average CPU {0}%, peak CPU {1}%"

#. placeholder {0}: bucket.avgCpuPercent.toFixed(1)
#. placeholder {1}: bucket.maxCpuPercent.toFixed(1)
#: src/components/settings/DiagnosticsSettings.tsx:644
msgid "Avg {0}%, peak {1}%"
msgstr "Avg {0}%, peak {1}%"

#: src/components/CommandPalette.tsx:405
#: src/components/CommandPalette.tsx:447
#: src/components/settings/SettingsSidebarNav.tsx:94
msgid "Back"
msgstr "Back"

#: src/components/settings/ConnectionsSettings.tsx:1384
msgid "Backend added"
msgstr "Backend added"

#: src/components/auth/PairingRouteSurface.tsx:237
msgid "Backend paired"
msgstr "Backend paired"

#: src/components/Sidebar.tsx:1584
msgid "Block chat"
msgstr "Block chat"

#: src/components/AddSafeProjectDialog.tsx:165
#: src/components/chat/ChatComposer.tsx:1717
#: src/components/DocumentsSidebar.tsx:873
#: src/components/settings/ConnectionsSettings.tsx:1038
#: src/components/settings/KeybindingsSettings.tsx:1081
#: src/components/Sidebar.tsx:1847
msgid "Cancel"
msgstr "Cancel"

#: src/components/settings/KeybindingsSettings.tsx:1073
msgid "Cancel new keybinding"
msgstr "Cancel new keybinding"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:28
msgid "Cancel recording"
msgstr "Cancel recording"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:30
msgid "Cancel transcription"
msgstr "Cancel transcription"

#: src/components/settings/settingsNavItems.ts:36
msgid "Capabilities"
msgstr "Capabilities"

#: src/components/settings/CapabilitiesSettings.tsx:171
msgid "Capabilities are pinned by the <0>T3CODE_FEATURE_FLAGS</0> override of this dev run; the flag files take over once the override is removed."
msgstr "Capabilities are pinned by the <0>T3CODE_FEATURE_FLAGS</0> override of this dev run; the flag files take over once the override is removed."

#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1157
msgid "Cause"
msgstr "Cause"

#: src/components/chat/DraftProjectChip.tsx:114
msgid "Change project"
msgstr "Change project"

#: src/components/chat/DraftProjectChip.tsx:101
msgid "Change the project for this draft"
msgstr "Change the project for this draft"

#: src/components/chat/MessagesTimeline.tsx:930
msgid "Changed files"
msgstr "Changed files"

#: src/components/chat/MessagesTimeline.tsx:1375
msgid "Changes"
msgstr "Changes"

#: src/components/CommandPalette.tsx:270
msgid "chat"
msgstr "chat"

#: src/components/chat/ComposerPrimaryActions.tsx:86
#: src/components/ThreadStatusIndicators.tsx:85
msgid "Chat blocked"
msgstr "Chat blocked"

#: src/components/Sidebar.tsx:1633
msgid "Chat blocked by an administrator."
msgstr "Chat blocked by an administrator."

#: src/components/chat/ThreadBlockedNotice.tsx:26
msgid "Chat blocked. <0>Reason</0>."
msgstr "Chat blocked. <0>Reason</0>."

#: src/components/settings/KeybindingsSettings.logic.ts:273
msgid "Chat: New"
msgstr "Chat: New"

#: src/components/settings/KeybindingsSettings.logic.ts:275
msgid "Chat: New Local"
msgstr "Chat: New Local"

#: src/hooks/useVoiceInput.ts:131
msgid "Check that a microphone is connected and not used by another application."
msgstr "Check that a microphone is connected and not used by another application."

#. placeholder {0}: relative.value
#: src/components/settings/DiagnosticsSettings.tsx:818
msgid "Checked {0}"
msgstr "Checked {0}"

#. placeholder {0}: relative.value
#. placeholder {1}: relative.suffix
#: src/components/settings/DiagnosticsSettings.tsx:814
msgid "Checked <0>{0}</0> {1}"
msgstr "Checked <0>{0}</0> {1}"

#: src/components/settings/DiagnosticsSettings.tsx:806
msgid "Checking"
msgstr "Checking"

#: src/components/settings/SettingsPanels.tsx:514
msgid "Checking connected environments."
msgstr "Checking connected environments."

#: src/components/settings/DiagnosticsSettings.tsx:580
msgid "Child process {name}"
msgstr "Child process {name}"

#: src/components/settings/DiagnosticsSettings.tsx:952
msgid "Child Processes"
msgstr "Child Processes"

#: src/components/CommandPalette.tsx:292
msgid "choose"
msgstr "choose"

#: src/components/chat/DraftProjectChip.tsx:99
msgid "Choose a project"
msgstr "Choose a project"

#: src/components/settings/SettingsPanels.tsx:196
msgid "Choose how {APP_BASE_NAME} looks across the app."
msgstr "Choose how {APP_BASE_NAME} looks across the app."

#: src/components/settings/ConnectionsSettings.tsx:1275
msgid "Click “Add environment” to pair another environment."
msgstr "Click “Add environment” to pair another environment."

#. placeholder {0}: versionMismatch.clientVersion
#. placeholder {1}: versionMismatch.serverVersion
#: src/components/ChatView.tsx:595
msgid "Client {0} is connected to {versionMismatchServerLabel} {1}. Sync them if RPC calls or reconnects fail."
msgstr "Client {0} is connected to {versionMismatchServerLabel} {1}. Sync them if RPC calls or reconnects fail."

#. placeholder {0}: primaryVersionMismatch.clientVersion
#. placeholder {1}: primaryVersionMismatch.serverVersion
#: src/components/settings/ConnectionsSettings.tsx:1666
msgid "Client {0}, server {1}. Sync them if RPC calls or reconnects fail."
msgstr "Client {0}, server {1}. Sync them if RPC calls or reconnects fail."

#: src/components/ChatView.tsx:593
msgid "Client and server versions differ"
msgstr "Client and server versions differ"

#: src/components/settings/ConnectionsSettings.tsx:866
msgid "Client label (optional)"
msgstr "Client label (optional)"

#: src/components/settings/ConnectionsSettings.tsx:761
msgid "Client scopes"
msgstr "Client scopes"

#: src/components/settings/ConnectionsSettings.tsx:635
msgid "Clipboard copy is unavailable here. Manually copy this code into another client."
msgstr "Clipboard copy is unavailable here. Manually copy this code into another client."

#: src/components/settings/ConnectionsSettings.tsx:630
msgid "Clipboard copy is unavailable here. Open or manually copy this full pairing URL on the device you want to connect."
msgstr "Clipboard copy is unavailable here. Open or manually copy this full pairing URL on the device you want to connect."

#: src/components/settings/ConnectionsSettings.tsx:452
msgid "Clipboard copy unavailable"
msgstr "Clipboard copy unavailable"

#: src/components/CommandPalette.tsx:307
#~ msgid "clone"
#~ msgstr "clone"

#: src/components/chat/BasaDocumentDialog.tsx:225
#: src/components/chat/ThreadBlockedNotice.tsx:46
#: src/components/CommandPalette.tsx:454
#: src/components/ui/dialog.tsx:81
#: src/components/ui/sheet.tsx:101
msgid "Close"
msgstr "Close"

#. placeholder {0}: label.toLowerCase()
#: src/components/PlanSidebar.tsx:78
msgid "Close {0} sidebar"
msgstr "Close {0} sidebar"

#: src/components/DocumentsSidebar.tsx:809
msgid "Close documents panel"
msgstr "Close documents panel"

#: src/components/chat/ExpandedImageDialog.tsx:71
#: src/components/chat/ExpandedImageDialog.tsx:93
msgid "Close image preview"
msgstr "Close image preview"

#: src/components/settings/CapabilitiesSettings.tsx:227
msgid "Codex model every turn runs with."
msgstr "Codex model every turn runs with."

#: src/components/settings/DiagnosticsSettings.tsx:331
msgid "Collapse {name}"
msgstr "Collapse {name}"

#: src/components/ChatMarkdown.tsx:259
msgid "Collapse table cells"
msgstr "Collapse table cells"

#: src/components/settings/DiagnosticsSettings.tsx:1056
msgid "Collecting process resource samples..."
msgstr "Collecting process resource samples..."

#: src/components/chat/MessagesTimeline.tsx:1494
#: src/components/settings/DiagnosticsSettings.tsx:477
#: src/components/settings/DiagnosticsSettings.tsx:733
#: src/components/settings/KeybindingsSettings.tsx:1002
#: src/components/settings/KeybindingsSettings.tsx:1256
msgid "Command"
msgstr "Command"

#: src/components/chat/MessagesTimeline.tsx:943
msgid "Command approval requested"
msgstr "Command approval requested"

#: src/components/CommandPalette.tsx:372
#: src/components/CommandPalette.tsx:385
msgid "Command palette"
msgstr "Command palette"

#: src/components/settings/KeybindingsSettings.logic.ts:271
msgid "Command Palette: Toggle"
msgstr "Command Palette: Toggle"

#: src/components/chat/MessagesTimeline.tsx:928
msgid "Command run"
msgstr "Command run"

#: src/components/settings/InspectSettings.tsx:24
#~ msgid "Commands, arguments, results and diffs behind each step, developer-only steps and provider warnings. Off, the chat reads exactly as a user sees it."
#~ msgstr "Commands, arguments, results and diffs behind each step, developer-only steps and provider warnings. Off, the chat reads exactly as a user sees it."

#: src/components/settings/InspectSettings.tsx:24
#~ msgid "Commands, arguments, results and diffs behind each step, expandable per row. Off, every step reads as a user sees it."
#~ msgstr "Commands, arguments, results and diffs behind each step, expandable per row. Off, every step reads as a user sees it."

#: src/components/settings/InspectSettings.tsx:24
msgid "Commands, arguments, results and diffs of steps, developer-only steps, provider warnings and model parameters."
msgstr "Commands, arguments, results and diffs of steps, developer-only steps, provider warnings and model parameters."

#: src/components/settings/ConnectionsSettings.tsx:133
#~ msgid "Commands, arguments, results, and diffs of agent tool calls."
#~ msgstr "Commands, arguments, results, and diffs of agent tool calls."

#: src/components/chat/MessagesTimeline.tsx:953
msgid "Compacting context…"
msgstr "Compacting context…"

#: src/components/Sidebar.logic.ts:38
msgid "Completed"
msgstr "Completed"

#: src/components/settings/KeybindingsSettings.tsx:314
#: src/components/settings/KeybindingsSettings.tsx:536
#: src/components/settings/KeybindingsSettings.tsx:653
#: src/components/settings/KeybindingsSettings.tsx:709
msgid "Condition"
msgstr "Condition"

#: src/components/CommandPalette.tsx:318
msgid "configuration"
msgstr "configuration"

#: src/components/settings/SettingsPanels.tsx:351
msgid "Confirm thread archiving"
msgstr "Confirm thread archiving"

#: src/components/settings/SettingsPanels.tsx:377
msgid "Confirm thread deletion"
msgstr "Confirm thread deletion"

#. placeholder {0}: labels.slice(0, 3).join(", ")
#: src/components/settings/KeybindingsSettings.tsx:268
msgid "Conflicts with {0}, and more."
msgstr "Conflicts with {0}, and more."

#. placeholder {0}: labels.join(", ")
#. placeholder {0}: labels[0]
#: src/components/settings/KeybindingsSettings.tsx:266
#: src/components/settings/KeybindingsSettings.tsx:269
msgid "Conflicts with {0}."
msgstr "Conflicts with {0}."

#: src/components/settings/ConnectionsSettings.tsx:1243
msgid "Connect"
msgstr "Connect"

#: src/routes/_chat.index.tsx:69
msgid "Connect an environment to get started"
msgstr "Connect an environment to get started"

#: src/components/settings/ConnectionsSettings.tsx:715
msgid "Connected"
msgstr "Connected"

#. placeholder {0}: formatElapsedDurationLabel(connectedAt, nowMs)
#. placeholder {0}: formatElapsedDurationLabel(lastConnectedAt, nowMs)
#: src/components/settings/ConnectionsSettings.tsx:243
#: src/components/settings/ConnectionsSettings.tsx:714
msgid "Connected for {0}"
msgstr "Connected for {0}"

#: src/components/chat/ComposerPrimaryActions.tsx:90
#: src/components/Sidebar.logic.ts:37
msgid "Connecting"
msgstr "Connecting"

#: src/components/auth/PairingRouteSurface.tsx:164
#: src/components/auth/PairingRouteSurface.tsx:189
msgid "Connecting to this backend."
msgstr "Connecting to this backend."

#: src/components/settings/ConnectionsSettings.tsx:1241
msgid "Connecting…"
msgstr "Connecting…"

#: src/components/WebSocketConnectionSurface.tsx:81
msgid "Connection restored at {reconnectedAtLabel}."
msgstr "Connection restored at {reconnectedAtLabel}."

#: src/components/WebSocketConnectionSurface.tsx:84
msgid "Connection restored."
msgstr "Connection restored."

#: src/components/ChatView.tsx:582
#: src/components/settings/settingsNavItems.ts:33
msgid "Connections"
msgstr "Connections"

#: src/components/chat/ProviderStatusBanner.tsx:38
msgid "Contact your administrator if this persists."
msgstr "Contact your administrator if this persists."

#: src/components/chat/MessagesTimeline.tsx:952
msgid "Context compacted"
msgstr "Context compacted"

#: src/components/chat/MessagesTimeline.tsx:954
msgid "Context compaction failed"
msgstr "Context compaction failed"

#: src/components/chat/ContextWindowMeter.tsx:82
msgid "Context Window"
msgstr "Context Window"

#. placeholder {0}: formatContextWindowTokens(usage.usedTokens)
#: src/components/chat/ContextWindowMeter.tsx:44
msgid "Context window {0} tokens used"
msgstr "Context window {0} tokens used"

#: src/components/chat/ContextWindowMeter.tsx:43
msgid "Context window {usedPercentage} used"
msgstr "Context window {usedPercentage} used"

#: src/components/chat/ContextWindowMeter.tsx:106
msgid "Context window usage"
msgstr "Context window usage"

#: src/components/auth/PairingRouteSurface.tsx:138
msgid "Continue"
msgstr "Continue"

#: src/components/ChatMarkdown.tsx:260
#: src/components/ChatMarkdown.tsx:505
#: src/components/settings/DiagnosticsSettings.tsx:287
msgid "Copied"
msgstr "Copied"

#: src/components/settings/DiagnosticsSettings.tsx:279
msgid "Copied trace ID"
msgstr "Copied trace ID"

#: src/components/chat/MessageCopyButton.tsx:22
msgid "Copied!"
msgstr "Copied!"

#: src/components/DocumentsSidebar.tsx:518
msgid "copy"
msgstr "copy"

#: src/components/ChatMarkdown.tsx:381
msgid "Copy as CSV"
msgstr "Copy as CSV"

#: src/components/ChatMarkdown.tsx:378
msgid "Copy as Markdown"
msgstr "Copy as Markdown"

#: src/components/ChatMarkdown.tsx:505
#: src/components/settings/ConnectionsSettings.tsx:509
#: src/components/settings/ConnectionsSettings.tsx:614
#: src/components/settings/ConnectionsSettings.tsx:669
msgid "Copy code"
msgstr "Copy code"

#: src/components/settings/DiagnosticsSettings.tsx:287
msgid "Copy full trace ID"
msgstr "Copy full trace ID"

#: src/components/chat/MessageCopyButton.tsx:67
msgid "Copy link"
msgstr "Copy link"

#: src/components/Sidebar.tsx:1577
msgid "Copy Link"
msgstr "Copy Link"

#: src/components/settings/ConnectionsSettings.tsx:590
msgid "Copy pairing link"
msgstr "Copy pairing link"

#: src/components/settings/ConnectionsSettings.tsx:592
msgid "Copy pairing URL"
msgstr "Copy pairing URL"

#: src/components/Sidebar.tsx:1389
msgid "Copy Path"
msgstr "Copy Path"

#: src/components/ChatMarkdown.tsx:260
msgid "Copy table"
msgstr "Copy table"

#: src/components/chat/BasaDocumentDialog.tsx:219
msgid "Copy text"
msgstr "Copy text"

#: src/components/settings/ConnectionsSettings.tsx:578
msgid "Copy the token and pair from another client using this backend's reachable host."
msgstr "Copy the token and pair from another client using this backend's reachable host."

#: src/components/Sidebar.tsx:1578
msgid "Copy Thread ID"
msgstr "Copy Thread ID"

#: src/components/chat/MessageCopyButton.tsx:82
msgid "Copy to clipboard"
msgstr "Copy to clipboard"

#: src/components/settings/DiagnosticsSettings.tsx:279
msgid "Copy trace ID"
msgstr "Copy trace ID"

#: src/components/settings/UsageSettings.tsx:123
msgid "Cost"
msgstr "Cost"

#. placeholder {0}: failures.length
#. placeholder {1}: files.length
#: src/components/DocumentsSidebar.tsx:461
msgid "Could not add {0} of {1} files to materials"
msgstr "Could not add {0} of {1} files to materials"

#: src/components/settings/ConnectionsSettings.tsx:1393
msgid "Could not add backend"
msgstr "Could not add backend"

#: src/components/settings/ConnectionsSettings.tsx:1414
msgid "Could not connect backend"
msgstr "Could not connect backend"

#: src/components/settings/ConnectionsSettings.tsx:451
msgid "Could not copy pairing code"
msgstr "Could not copy pairing code"

#: src/components/settings/ConnectionsSettings.tsx:450
msgid "Could not copy pairing URL"
msgstr "Could not copy pairing URL"

#: src/components/settings/ConnectionsSettings.tsx:815
msgid "Could not create pairing URL"
msgstr "Could not create pairing URL"

#. placeholder {0}: failures.length
#. placeholder {1}: files.length
#: src/components/DocumentsSidebar.tsx:381
msgid "Could not delete {0} of {1} documents"
msgstr "Could not delete {0} of {1} documents"

#. placeholder {0}: failures.length
#. placeholder {1}: files.length
#: src/components/DocumentsSidebar.tsx:420
msgid "Could not delete {0} of {1} files"
msgstr "Could not delete {0} of {1} files"

#: src/components/settings/ConnectionsSettings.tsx:1437
msgid "Could not disconnect backend"
msgstr "Could not disconnect backend"

#: src/components/settings/SettingsPanels.tsx:508
msgid "Could not load archived threads"
msgstr "Could not load archived threads"

#: src/components/chat/BasaDocumentDialog.tsx:207
msgid "Could not load the document."
msgstr "Could not load the document."

#: src/components/ChatView.tsx:462
msgid "Could not reconnect environment"
msgstr "Could not reconnect environment"

#: src/components/settings/ConnectionsSettings.tsx:1460
msgid "Could not remove backend"
msgstr "Could not remove backend"

#: src/components/settings/ConnectionsSettings.tsx:1356
msgid "Could not revoke client access"
msgstr "Could not revoke client access"

#: src/components/settings/ConnectionsSettings.tsx:1333
msgid "Could not revoke pairing link"
msgstr "Could not revoke pairing link"

#: src/components/settings/DiagnosticsSettings.tsx:907
#: src/components/settings/DiagnosticsSettings.tsx:917
msgid "Could not send {signal}"
msgstr "Could not send {signal}"

#: src/components/chat/ChatComposer.tsx:1119
msgid "Could not transcribe the audio"
msgstr "Could not transcribe the audio"

#: src/components/settings/DiagnosticsSettings.tsx:1157
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Count"
msgstr "Count"

#: src/components/settings/DiagnosticsSettings.tsx:471
#: src/components/settings/DiagnosticsSettings.tsx:956
msgid "CPU"
msgstr "CPU"

#: src/components/settings/DiagnosticsSettings.tsx:718
#: src/components/settings/DiagnosticsSettings.tsx:1017
msgid "CPU Time"
msgstr "CPU Time"

#: src/components/CommandPalette.tsx:270
msgid "create"
msgstr "create"

#: src/components/settings/ConnectionsSettings.tsx:117
msgid "Create comments while reviewing changes."
msgstr "Create comments while reviewing changes."

#: src/components/settings/ConnectionsSettings.tsx:848
#: src/components/settings/ConnectionsSettings.tsx:1044
msgid "Create link"
msgstr "Create link"

#: src/components/settings/ConnectionsSettings.tsx:855
msgid "Create pairing link"
msgstr "Create pairing link"

#: src/components/DocumentsSidebar.tsx:789
msgid "Created"
msgstr "Created"

#: src/components/Sidebar.tsx:174
#: src/components/Sidebar.tsx:179
msgid "Created at"
msgstr "Created at"

#: src/components/settings/ConnectionsSettings.tsx:1044
msgid "Creating…"
msgstr "Creating…"

#: src/components/settings/DiagnosticsSettings.tsx:721
msgid "Current"
msgstr "Current"

#: src/components/CommandPalette.logic.ts:116
msgid "Current thread"
msgstr "Current thread"

#: src/components/settings/SettingsPanels.tsx:83
msgid "Current version of the application."
msgstr "Current version of the application."

#: src/components/settings/SettingsPanels.tsx:55
msgid "Dark"
msgstr "Dark"

#: src/components/Sidebar.tsx:1994
msgid "Decrease visible thread count"
msgstr "Decrease visible thread count"

#: src/components/chat/ChatComposer.tsx:161
#: src/components/chat/CompactComposerControlsMenu.tsx:33
#: src/components/settings/CapabilitiesSettings.tsx:53
msgid "Deep Work"
msgstr "Deep Work"

#: src/components/chat/ChatComposer.tsx:135
msgid "Deep Work disabled — click to enable"
msgstr "Deep Work disabled — click to enable"

#: src/components/chat/ChatComposer.tsx:134
msgid "Deep Work enabled — click to disable"
msgstr "Deep Work enabled — click to disable"

#: src/components/chat/ChatComposer.tsx:1709
msgid "Deep Work mode searches and analyzes materials more thoroughly. It is recommended for the most complex tasks and can take a long time."
msgstr "Deep Work mode searches and analyzes materials more thoroughly. It is recommended for the most complex tasks and can take a long time."

#: src/components/settings/CapabilitiesSettings.tsx:54
msgid "Deep Work toggle in the composer."
msgstr "Deep Work toggle in the composer."

#: src/components/DocumentsSidebar.tsx:663
#: src/components/DocumentsSidebar.tsx:865
#: src/components/settings/SettingsPanels.tsx:464
#: src/components/Sidebar.tsx:1589
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: files[0]?.path
#: src/components/DocumentsSidebar.tsx:355
msgid "Delete \"{0}\" from materials? The agent will no longer see it."
msgstr "Delete \"{0}\" from materials? The agent will no longer see it."

#. placeholder {0}: files[0]?.path
#: src/components/DocumentsSidebar.tsx:398
msgid "Delete \"{0}\"? This cannot be undone."
msgstr "Delete \"{0}\"? This cannot be undone."

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:356
msgid "Delete {0} files from materials? The agent will no longer see them."
msgstr "Delete {0} files from materials? The agent will no longer see them."

#. placeholder {0}: files.length
#: src/components/DocumentsSidebar.tsx:399
msgid "Delete {0} files? This cannot be undone."
msgstr "Delete {0} files? This cannot be undone."

#: src/components/Sidebar.tsx:1090
msgid "Delete all threads in this project before removing it."
msgstr "Delete all threads in this project before removing it."

#: src/components/Sidebar.tsx:1093
msgid "Delete anyway"
msgstr "Delete anyway"

#: src/components/settings/SettingsPanels.tsx:362
msgid "delete confirmation"
msgstr "delete confirmation"

#: src/components/settings/SettingsPanels.tsx:142
#: src/components/settings/SettingsPanels.tsx:357
msgid "Delete confirmation"
msgstr "Delete confirmation"

#: src/components/DocumentsSidebar.tsx:599
msgid "Delete from materials"
msgstr "Delete from materials"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:31
msgid "Delete recording"
msgstr "Delete recording"

#. placeholder {0}: thread.title
#: src/components/Sidebar.tsx:1660
msgid "Delete thread \"{0}\"?"
msgstr "Delete thread \"{0}\"?"

#: src/components/chat/ChatComposer.tsx:1544
#: src/components/chat/ChatComposer.tsx:1620
msgid "Describe a task or ask a question"
msgstr "Describe a task or ask a question"

#: src/components/chat/MessagesTimeline.tsx:1525
msgid "Details"
msgstr "Details"

#: src/components/settings/InspectSettings.tsx:21
msgid "Developer settings"
msgstr "Developer settings"

#: src/components/settings/ConnectionsSettings.tsx:941
#: src/components/settings/ConnectionsSettings.tsx:955
msgid "Devices"
msgstr "Devices"

#: src/components/settings/settingsNavItems.ts:42
msgid "Diagnostics"
msgstr "Diagnostics"

#: src/components/CommandPalette.tsx:306
msgid "directory"
msgstr "directory"

#: src/components/ChatMarkdown.tsx:504
msgid "Disable line wrap"
msgstr "Disable line wrap"

#: src/components/settings/ConnectionsSettings.tsx:1238
msgid "Disconnect"
msgstr "Disconnect"

#: src/components/WebSocketConnectionSurface.tsx:77
msgid "Disconnected at {disconnectedAtLabel} and reconnected at {reconnectedAtLabel}."
msgstr "Disconnected at {disconnectedAtLabel} and reconnected at {reconnectedAtLabel}."

#. placeholder {0}: getConnectionDisplayName(status)
#: src/components/WebSocketConnectionSurface.tsx:62
msgid "Disconnected from {0}"
msgstr "Disconnected from {0}"

#: src/components/settings/ConnectionsSettings.tsx:1236
msgid "Disconnecting…"
msgstr "Disconnecting…"

#: src/components/chat/ThreadErrorBanner.tsx:31
msgid "Dismiss error"
msgstr "Dismiss error"

#: src/components/ChatView.tsx:600
msgid "Dismiss version mismatch warning"
msgstr "Dismiss version mismatch warning"

#: src/components/chat/ComposerBannerStack.tsx:186
msgid "Dismiss warning"
msgstr "Dismiss warning"

#: src/components/DocumentsSidebar.tsx:577
msgid "Document actions"
msgstr "Document actions"

#: src/components/DocumentsSidebar.tsx:375
msgid "Document deleted"
msgstr "Document deleted"

#: src/components/chat/DocumentsHeaderButton.tsx:24
#: src/components/settings/UsageSettings.tsx:111
#: src/components/Sidebar.tsx:1386
msgid "Documents"
msgstr "Documents"

#: src/components/DocumentsSidebar.tsx:719
msgid "Documents are unavailable until this thread has an active project."
msgstr "Documents are unavailable until this thread has an active project."

#: src/components/settings/ConnectionsSettings.tsx:665
msgid "Done"
msgstr "Done"

#: src/components/DocumentsSidebar.tsx:657
msgid "Download file"
msgstr "Download file"

#: src/components/DocumentsSidebar.tsx:588
msgid "Download original"
msgstr "Download original"

#: src/components/DocumentsSidebar.tsx:595
msgid "Download parsed JSON"
msgstr "Download parsed JSON"

#: src/components/CommandPalette.tsx:270
msgid "draft"
msgstr "draft"

#: src/components/chat/AttachmentsBlock.tsx:166
msgid "Draft attachment could not be saved locally and may be lost on navigation."
msgstr "Draft attachment could not be saved locally and may be lost on navigation."

#: src/components/chat/AttachmentsBlock.tsx:158
msgid "Draft attachment may not persist"
msgstr "Draft attachment may not persist"

#: src/components/chat/MessagesTimeline.tsx:1473
#: src/components/chat/TurnInspectionButton.tsx:119
#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1187
msgid "Duration"
msgstr "Duration"

#: src/components/chat/MessagesTimeline.tsx:1332
msgid "Dynamic tool"
msgstr "Dynamic tool"

#: src/components/settings/ConnectionsSettings.tsx:871
msgid "e.g. Living room iPad"
msgstr "e.g. Living room iPad"

#: src/components/settings/KeybindingsSettings.tsx:848
msgid "Edit"
msgstr "Edit"

#. placeholder {0}: commandLabel(row.command)
#: src/components/settings/KeybindingsSettings.tsx:843
msgid "Edit shortcut for {0}"
msgstr "Edit shortcut for {0}"

#. placeholder {0}: commandLabel(row.command)
#: src/components/settings/KeybindingsSettings.tsx:885
msgid "Edit when clause for {0}"
msgstr "Edit when clause for {0}"

#: src/components/settings/KeybindingsSettings.tsx:1047
msgid "Edit when clause for {commandLabelText}"
msgstr "Edit when clause for {commandLabelText}"

#: src/components/chat/TurnInspectionButton.tsx:103
msgid "Effort"
msgstr "Effort"

#: src/components/chat/UserMessageRail.tsx:218
msgid "Empty message"
msgstr "Empty message"

#: src/components/chat/ChatComposer.tsx:1720
msgid "Enable"
msgstr "Enable"

#: src/components/chat/ChatComposer.tsx:1706
msgid "Enable Deep Work?"
msgstr "Enable Deep Work?"

#: src/components/settings/ConnectionsSettings.tsx:1639
msgid "Enable network access"
msgstr "Enable network access"

#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1187
msgid "Ended"
msgstr "Ended"

#: src/components/settings/ConnectionsSettings.tsx:300
msgid "Enter a backend host."
msgstr "Enter a backend host."

#: src/components/settings/ConnectionsSettings.tsx:303
msgid "Enter a pairing code."
msgstr "Enter a pairing code."

#: src/environments/primary/auth.ts:335
msgid "Enter a pairing token to continue."
msgstr "Enter a pairing token to continue."

#: src/components/auth/PairingRouteSurface.tsx:118
msgid "Enter your personal token to get started"
msgstr "Enter your personal token to get started"

#: src/components/chat/ComposerPrimaryActions.tsx:88
msgid "Environment disconnected"
msgstr "Environment disconnected"

#: src/components/ChatView.tsx:455
msgid "Environment reconnected"
msgstr "Environment reconnected"

#. placeholder {0}: member.environmentLabel
#. placeholder {0}: projectRenameTarget.environmentLabel
#: src/components/Sidebar.tsx:1114
#: src/components/Sidebar.tsx:1124
#: src/components/Sidebar.tsx:1160
#: src/components/Sidebar.tsx:1841
msgid "Environment: {0}"
msgstr "Environment: {0}"

#: src/components/chat/MessagesTimeline.tsx:941
#: src/components/chat/MessagesTimeline.tsx:1436
#: src/components/DocumentsSidebar.tsx:492
msgid "Error"
msgstr "Error"

#: src/components/settings/ConnectionsSettings.tsx:977
msgid "Every device that opens the link gets its own session."
msgstr "Every device that opens the link gets its own session."

#. placeholder {0}: entry.exitCode
#: src/components/chat/MessagesTimeline.tsx:1401
#~ msgid "Exit code {0}"
#~ msgstr "Exit code {0}"

#: src/components/chat/MessagesTimeline.tsx:1434
msgid "Exit code {exitCode}"
msgstr "Exit code {exitCode}"

#: src/components/settings/DiagnosticsSettings.tsx:331
msgid "Expand {name}"
msgstr "Expand {name}"

#: src/components/chat/ChatComposer.tsx:1542
msgid "Expand composer"
msgstr "Expand composer"

#: src/components/ChatMarkdown.tsx:259
msgid "Expand table cells"
msgstr "Expand table cells"

#: src/components/chat/ExpandedImageDialog.tsx:66
msgid "Expanded image preview"
msgstr "Expanded image preview"

#: src/timestampFormat.ts:104
#: src/timestampFormat.ts:122
msgid "Expired"
msgstr "Expired"

#. placeholder {0}: formatDuration(0, 0, 0, totalSeconds)
#. placeholder {0}: formatDuration(0, 0, minutes, seconds)
#. placeholder {0}: formatDuration(0, hours, Math.floor(rem / 60), rem % 60)
#: src/timestampFormat.ts:126
#: src/timestampFormat.ts:131
#: src/timestampFormat.ts:137
#: src/timestampFormat.ts:144
msgid "Expires in {0}"
msgstr "Expires in {0}"

#: src/timestampFormat.ts:125
msgid "Expires in a moment"
msgstr "Expires in a moment"

#: src/components/chat/taskStatusLabels.ts:12
msgid "failed"
msgstr "failed"

#: src/components/settings/ConnectionsSettings.tsx:1388
msgid "Failed to add backend."
msgstr "Failed to add backend."

#: src/components/AddSafeProjectDialog.tsx:130
msgid "Failed to add project"
msgstr "Failed to add project"

#: src/components/Sidebar.tsx:1442
msgid "Failed to archive thread"
msgstr "Failed to archive thread"

#: src/components/Sidebar.tsx:1641
msgid "Failed to block chat"
msgstr "Failed to block chat"

#: src/environments/primary/auth.ts:230
msgid "Failed to bootstrap auth session ({status})."
msgstr "Failed to bootstrap auth session ({status})."

#: src/components/settings/ConnectionsSettings.tsx:1409
msgid "Failed to connect backend."
msgstr "Failed to connect backend."

#: src/components/chat/MessageCopyButton.tsx:37
msgid "Failed to copy"
msgstr "Failed to copy"

#: src/components/Sidebar.tsx:795
msgid "Failed to copy link"
msgstr "Failed to copy link"

#: src/components/Sidebar.tsx:775
msgid "Failed to copy path"
msgstr "Failed to copy path"

#: src/components/Sidebar.tsx:755
msgid "Failed to copy thread ID"
msgstr "Failed to copy thread ID"

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:372
msgid "Failed to create pairing credential ({0})."
msgstr "Failed to create pairing credential ({0})."

#: src/components/settings/ConnectionsSettings.tsx:811
msgid "Failed to create pairing URL."
msgstr "Failed to create pairing URL."

#: src/components/settings/ConnectionsSettings.tsx:1432
msgid "Failed to disconnect backend."
msgstr "Failed to disconnect backend."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:477
msgid "Failed to load paired clients ({0})."
msgstr "Failed to load paired clients ({0})."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:424
msgid "Failed to load pairing links ({0})."
msgstr "Failed to load pairing links ({0})."

#: src/environments/primary/auth.ts:151
msgid "Failed to load server auth session state ({statusLabel})."
msgstr "Failed to load server auth session state ({statusLabel})."

#: src/environments/primary/context.ts:65
msgid "Failed to load server environment descriptor ({status})."
msgstr "Failed to load server environment descriptor ({status})."

#: src/components/ChatView.tsx:463
msgid "Failed to reconnect."
msgstr "Failed to reconnect."

#: src/components/Sidebar.tsx:1145
#: src/components/Sidebar.tsx:1180
msgid "Failed to remove \"\""
msgstr "Failed to remove \"\""

#: src/components/settings/ConnectionsSettings.tsx:1455
msgid "Failed to remove backend."
msgstr "Failed to remove backend."

#: src/components/Sidebar.tsx:1535
#: src/components/Sidebar.tsx:1554
msgid "Failed to rename project"
msgstr "Failed to rename project"

#: src/components/Sidebar.tsx:1496
msgid "Failed to rename thread"
msgstr "Failed to rename thread"

#: src/components/ChatView.tsx:1064
#~ msgid "Failed to revert thread state."
#~ msgstr "Failed to revert thread state."

#: src/components/settings/ConnectionsSettings.tsx:1351
msgid "Failed to revoke client access."
msgstr "Failed to revoke client access."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:497
msgid "Failed to revoke client session ({0})."
msgstr "Failed to revoke client session ({0})."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:516
msgid "Failed to revoke other client sessions ({0})."
msgstr "Failed to revoke other client sessions ({0})."

#. placeholder {0}: readHttpApiStatus(error) ?? "unknown"
#: src/environments/primary/auth.ts:442
msgid "Failed to revoke pairing link ({0})."
msgstr "Failed to revoke pairing link ({0})."

#: src/components/settings/ConnectionsSettings.tsx:1328
msgid "Failed to revoke pairing link."
msgstr "Failed to revoke pairing link."

#: src/components/settings/DiagnosticsSettings.tsx:908
#: src/components/settings/DiagnosticsSettings.tsx:918
msgid "Failed to send {signal}."
msgstr "Failed to send {signal}."

#: src/components/ChatView.tsx:1249
msgid "Failed to send message."
msgstr "Failed to send message."

#: src/components/settings/SettingsPanels.tsx:477
#: src/components/settings/SettingsPanels.tsx:560
msgid "Failed to unarchive thread"
msgstr "Failed to unarchive thread"

#: src/components/Sidebar.tsx:1641
msgid "Failed to unblock chat"
msgstr "Failed to unblock chat"

#: src/components/settings/DiagnosticsSettings.tsx:1078
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Failures"
msgstr "Failures"

#: src/components/chat/TurnInspectionButton.tsx:106
msgid "Fast"
msgstr "Fast"

#: src/components/settings/CapabilitiesSettings.tsx:291
#: src/components/settings/CapabilitiesSettings.tsx:300
msgid "Fast mode"
msgstr "Fast mode"

#: src/components/settings/CapabilitiesSettings.tsx:292
msgid "Faster responses at a higher usage cost."
msgstr "Faster responses at a higher usage cost."

#: src/components/chat/MessagesTimeline.tsx:1511
msgid "File"
msgstr "File"

#: src/components/DocumentsSidebar.tsx:646
msgid "File actions"
msgstr "File actions"

#: src/components/chat/MessagesTimeline.tsx:929
#: src/components/chat/MessagesTimeline.tsx:1329
msgid "File change"
msgstr "File change"

#: src/components/DocumentsSidebar.tsx:414
msgid "File deleted"
msgstr "File deleted"

#: src/components/chat/MessagesTimeline.tsx:945
msgid "File-change approval requested"
msgstr "File-change approval requested"

#: src/components/chat/MessagesTimeline.tsx:944
msgid "File-read approval requested"
msgstr "File-read approval requested"

#: src/components/ChatView.tsx:1178
msgid "File: {firstComposerFileName}"
msgstr "File: {firstComposerFileName}"

#: src/components/chat/MessagesTimeline.tsx:1516
msgid "Files"
msgstr "Files"

#: src/components/DocumentsSidebar.tsx:747
msgid "Files the agent creates will appear here."
msgstr "Files the agent creates will appear here."

#: src/components/chat/taskStatusLabels.ts:11
msgid "finished"
msgstr "finished"

#: src/components/settings/KeybindingsSettings.tsx:726
msgid "Fix the expression above to continue editing visually."
msgstr "Fix the expression above to continue editing visually."

#: src/components/CommandPalette.tsx:305
msgid "folder"
msgstr "folder"

#: src/components/chat/BasaDocumentDialog.tsx:213
msgid "Full text"
msgstr "Full text"

#: src/components/settings/settingsNavItems.ts:31
#: src/components/settings/SettingsPanels.tsx:193
msgid "General"
msgstr "General"

#: src/components/settings/ConnectionsSettings.tsx:858
msgid "Generate a link that pairs devices with this backend as an authorized client."
msgstr "Generate a link that pairs devices with this backend as an authorized client."

#: src/components/Sidebar.tsx:2064
msgid "Go to threads"
msgstr "Go to threads"

#: src/components/settings/ConnectionsSettings.tsx:167
#: src/components/settings/ConnectionsSettings.tsx:1211
msgid "Granted scopes"
msgstr "Granted scopes"

#: src/components/settings/KeybindingsSettings.tsx:540
#: src/components/settings/KeybindingsSettings.tsx:663
#: src/components/settings/KeybindingsSettings.tsx:719
msgid "Group"
msgstr "Group"

#: src/components/Sidebar.tsx:189
#~ msgid "Group by repository"
#~ msgstr "Group by repository"

#: src/components/Sidebar.tsx:190
#~ msgid "Group by repository path"
#~ msgstr "Group by repository path"

#: src/components/Sidebar.tsx:2034
#~ msgid "Group projects"
#~ msgstr "Group projects"

#: src/components/chat/MessagesTimeline.tsx:1331
msgid "Helper agent"
msgstr "Helper agent"

#: src/components/chat/ChatComposer.tsx:130
#: src/components/chat/CompactComposerControlsMenu.tsx:60
msgid "Hide {planSidebarLabel} sidebar"
msgstr "Hide {planSidebarLabel} sidebar"

#: src/routes/__root.tsx:215
msgid "Hide error details"
msgstr "Hide error details"

#: src/components/chat/MessagesTimeline.tsx:1110
msgid "Hide raw details"
msgstr "Hide raw details"

#: src/components/WebSocketConnectionSurface.tsx:523
msgid "Hide requests"
msgstr "Hide requests"

#: src/components/settings/ConnectionsSettings.tsx:1560
msgid "Host"
msgstr "Host"

#. placeholder {0}: request.host
#: src/components/auth/PairingRouteSurface.tsx:248
msgid "Host: <0>{0}</0>"
msgstr "Host: <0>{0}</0>"

#: src/components/settings/ConnectionsSettings.tsx:944
msgid "How many devices can pair with this link."
msgstr "How many devices can pair with this link."

#: src/components/settings/CapabilitiesSettings.tsx:261
msgid "How much the model reasons before it answers."
msgstr "How much the model reasons before it answers."

#: src/components/chat/MessagesTimeline.tsx:934
#: src/components/chat/MessagesTimeline.tsx:1328
msgid "Image view"
msgstr "Image view"

#: src/components/ChatView.tsx:1176
msgid "Image: {firstComposerImageName}"
msgstr "Image: {firstComposerImageName}"

#: src/components/settings/DiagnosticsSettings.tsx:1024
msgid "In-memory process samples retained by the server. This resets when the server restarts."
msgstr "In-memory process samples retained by the server. This resets when the server restarts."

#: src/components/Sidebar.tsx:2006
msgid "Increase visible thread count"
msgstr "Increase visible thread count"

#: src/components/chat/TurnInspectionButton.tsx:110
msgid "Input"
msgstr "Input"

#: src/components/chat/TurnInspectionButton.tsx:111
msgid "Input (cached)"
msgstr "Input (cached)"

#: src/components/settings/ConnectionsSettings.tsx:132
#~ msgid "Inspect agent actions"
#~ msgstr "Inspect agent actions"

#: src/components/settings/ConnectionsSettings.tsx:122
msgid "Inspect pairing links and authorized clients."
msgstr "Inspect pairing links and authorized clients."

#: src/components/ChatView.tsx:1037
#~ msgid "Interrupt the current turn before reverting checkpoints."
#~ msgstr "Interrupt the current turn before reverting checkpoints."

#: src/components/settings/DiagnosticsSettings.tsx:1027
msgid "Interval"
msgstr "Interval"

#: src/environments/primary/auth.ts:193
msgid "Invalid bootstrap credential."
msgstr "Invalid bootstrap credential."

#: src/routes/__root.tsx:375
msgid "Invalid keybindings configuration"
msgstr "Invalid keybindings configuration"

#: src/environments/primary/auth.ts:227
msgid "Invalid pairing token. Check the token and try again."
msgstr "Invalid pairing token. Check the token and try again."

#: src/components/settings/ConnectionsSettings.tsx:127
msgid "Issue and revoke credentials for other clients."
msgstr "Issue and revoke credentials for other clients."

#: src/components/chat/ContextWindowMeter.tsx:128
#~ msgid "It automatically compacts its context when needed."
#~ msgstr "It automatically compacts its context when needed."

#: src/components/chat/MessagesTimeline.tsx:942
msgid "Item"
msgstr "Item"

#: src/components/chat/UserMessageRail.tsx:183
msgid "Jump to message"
msgstr "Jump to message"

#: src/components/settings/ConnectionsSettings.tsx:490
#: src/timestampFormat.ts:61
#: src/timestampFormat.ts:63
#: src/timestampFormat.ts:83
#: src/timestampFormat.ts:86
msgid "just now"
msgstr "just now"

#: src/components/Sidebar.tsx:191
#~ msgid "Keep separate"
#~ msgstr "Keep separate"

#: src/components/settings/KeybindingsSettings.tsx:1259
msgid "Keybinding"
msgstr "Keybinding"

#. placeholder {0}: commandLabel(row.command)
#: src/components/settings/KeybindingsSettings.tsx:854
msgid "Keybinding for {0}"
msgstr "Keybinding for {0}"

#: src/components/settings/KeybindingsSettings.tsx:1019
msgid "Keybinding for {commandLabelText}"
msgstr "Keybinding for {commandLabelText}"

#: src/components/CommandPalette.tsx:318
msgid "keybindings"
msgstr "keybindings"

#: src/components/settings/KeybindingsSettings.tsx:1206
#: src/components/settings/settingsNavItems.ts:32
msgid "Keybindings"
msgstr "Keybindings"

#: src/routes/__root.tsx:367
msgid "Keybindings configuration reloaded successfully."
msgstr "Keybindings configuration reloaded successfully."

#: src/routes/__root.tsx:366
msgid "Keybindings updated"
msgstr "Keybindings updated"

#: src/components/settings/DiagnosticsSettings.tsx:486
msgid "Kill"
msgstr "Kill"

#: src/components/settings/SettingsPanels.tsx:234
msgid "language"
msgstr "language"

#: src/components/settings/SettingsPanels.tsx:128
#: src/components/settings/SettingsPanels.tsx:230
msgid "Language"
msgstr "Language"

#: src/components/settings/SettingsPanels.tsx:231
msgid "Language of the app interface."
msgstr "Language of the app interface."

#: src/components/settings/SettingsPanels.tsx:246
msgid "Language preference"
msgstr "Language preference"

#. placeholder {0}: formatAccessTimestamp(record.lastConnectedAt)
#: src/components/settings/ConnectionsSettings.tsx:1188
msgid "Last connected {0}"
msgstr "Last connected {0}"

#. placeholder {0}: formatAccessTimestamp(lastConnectedAt)
#. placeholder {0}: formatAccessTimestamp(record.lastConnectedAt)
#: src/components/settings/ConnectionsSettings.tsx:255
#: src/components/settings/ConnectionsSettings.tsx:717
msgid "Last connected at {0}"
msgstr "Last connected at {0}"

#: src/components/settings/DiagnosticsSettings.tsx:1157
msgid "Last Seen"
msgstr "Last Seen"

#: src/components/chat/MessagesTimeline.tsx:1441
#~ msgid "Last tool: {lastToolName}"
#~ msgstr "Last tool: {lastToolName}"

#: src/components/Sidebar.tsx:173
#: src/components/Sidebar.tsx:178
msgid "Last user message"
msgstr "Last user message"

#: src/components/settings/SettingsPanels.tsx:104
msgid "Latest"
msgstr "Latest"

#: src/components/settings/DiagnosticsSettings.tsx:1127
msgid "Latest Failures"
msgstr "Latest Failures"

#: src/timestampFormat.ts:107
#: src/timestampFormat.ts:109
#: src/timestampFormat.ts:111
#: src/timestampFormat.ts:113
msgid "left"
msgstr "left"

#: src/components/settings/DiagnosticsSettings.tsx:1235
msgid "Level"
msgstr "Level"

#: src/components/settings/ConnectionsSettings.tsx:987
#: src/components/settings/ConnectionsSettings.tsx:1003
msgid "Lifetime"
msgstr "Lifetime"

#: src/components/settings/SettingsPanels.tsx:51
msgid "Light"
msgstr "Light"

#: src/components/settings/ConnectionsSettings.tsx:883
msgid "Limit what the paired client can do."
msgstr "Limit what the paired client can do."

#: src/components/Sidebar.tsx:787
msgid "Link copied"
msgstr "Link copied"

#. placeholder {0}: formatAccessTimestamp(pairingLink.createdAt)
#: src/components/settings/ConnectionsSettings.tsx:526
msgid "Link created at {0}"
msgstr "Link created at {0}"

#: src/components/settings/DiagnosticsSettings.tsx:938
msgid "Live Processes"
msgstr "Live Processes"

#: src/components/chat/MessagesTimeline.tsx:1394
msgid "Load full payload"
msgstr "Load full payload"

#: src/components/settings/SettingsPanels.tsx:506
msgid "Loading archived threads"
msgstr "Loading archived threads"

#: src/components/chat/MessagesTimeline.tsx:342
msgid "Loading chat"
msgstr "Loading chat"

#: src/components/chat/MessagesTimeline.tsx:266
msgid "Loading earlier messages…"
msgstr "Loading earlier messages…"

#: src/components/settings/DiagnosticsSettings.tsx:1179
msgid "Loading failure groups..."
msgstr "Loading failure groups..."

#: src/components/settings/DiagnosticsSettings.tsx:1149
msgid "Loading failures..."
msgstr "Loading failures..."

#: src/components/settings/DiagnosticsSettings.tsx:992
msgid "Loading live processes..."
msgstr "Loading live processes..."

#: src/components/settings/DiagnosticsSettings.tsx:1282
msgid "Loading recent logs..."
msgstr "Loading recent logs..."

#: src/components/settings/DiagnosticsSettings.tsx:1209
msgid "Loading slow spans..."
msgstr "Loading slow spans..."

#: src/components/settings/DiagnosticsSettings.tsx:1315
msgid "Loading span names..."
msgstr "Loading span names..."

#: src/components/chat/BasaDocumentDialog.tsx:232
#: src/components/chat/MessagesTimeline.tsx:1394
msgid "Loading…"
msgstr "Loading…"

#: src/components/settings/ConnectionsSettings.tsx:126
msgid "Manage access"
msgstr "Manage access"

#: src/components/Sidebar.tsx:175
msgid "Manual"
msgstr "Manual"

#: src/components/Sidebar.tsx:1575
msgid "Mark unread"
msgstr "Mark unread"

#: src/components/DocumentsSidebar.tsx:783
msgid "Materials"
msgstr "Materials"

#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Max"
msgstr "Max"

#: src/components/settings/DiagnosticsSettings.tsx:730
msgid "Max Mem"
msgstr "Max Mem"

#: src/components/chat/MessagesTimeline.tsx:1327
msgid "MCP tool"
msgstr "MCP tool"

#: src/components/chat/MessagesTimeline.tsx:935
msgid "MCP tool call"
msgstr "MCP tool call"

#: src/components/settings/DiagnosticsSettings.tsx:474
#: src/components/settings/DiagnosticsSettings.tsx:961
msgid "Memory"
msgstr "Memory"

#: src/components/settings/DiagnosticsSettings.tsx:1241
msgid "Message"
msgstr "Message"

#: src/hooks/useVoiceInput.ts:151
msgid "Microphone access granted"
msgstr "Microphone access granted"

#: src/hooks/useVoiceInput.ts:125
msgid "Microphone access is blocked"
msgstr "Microphone access is blocked"

#: src/components/settings/CapabilitiesSettings.tsx:50
msgid "Microphone button in the composer; recordings are transcribed through docparser."
msgstr "Microphone button in the composer; recordings are transcribed through docparser."

#: src/hooks/useVoiceInput.ts:130
msgid "Microphone is unavailable"
msgstr "Microphone is unavailable"

#: src/components/settings/CapabilitiesSettings.tsx:231
msgid "model"
msgstr "model"

#: src/components/chat/TurnInspectionButton.tsx:100
#: src/components/settings/CapabilitiesSettings.tsx:226
#: src/components/settings/CapabilitiesSettings.tsx:245
msgid "Model"
msgstr "Model"

#: src/components/DocumentsSidebar.tsx:564
#: src/components/DocumentsSidebar.tsx:633
msgid "Modified"
msgstr "Modified"

#: src/components/chat/CompactComposerControlsMenu.tsx:77
msgid "More composer controls"
msgstr "More composer controls"

#: src/components/settings/ConnectionsSettings.tsx:601
msgid "More copy options"
msgstr "More copy options"

#: src/components/settings/DiagnosticsSettings.tsx:1154
msgid "Most Common Failures"
msgstr "Most Common Failures"

#: src/components/DocumentsSidebar.tsx:504
#: src/components/DocumentsSidebar.tsx:615
#: src/components/settings/DiagnosticsSettings.tsx:468
msgid "Name"
msgstr "Name"

#: src/components/CommandPalette.tsx:434
msgid "Navigate"
msgstr "Navigate"

#. placeholder {0}: condition.identifier
#: src/components/settings/KeybindingsSettings.tsx:365
msgid "Negate {0}"
msgstr "Negate {0}"

#: src/components/settings/KeybindingsSettings.tsx:406
msgid "Negate group"
msgstr "Negate group"

#: src/components/settings/ConnectionsSettings.tsx:1625
msgid "Network access"
msgstr "Network access"

#: src/components/settings/ConnectionsSettings.tsx:1645
msgid "Network exposure changes restart the backend and must be controlled where the server process is launched."
msgstr "Network exposure changes restart the backend and must be controlled where the server process is launched."

#: src/components/settings/ConnectionsSettings.tsx:477
#: src/components/settings/ConnectionsSettings.tsx:481
msgid "Never expires"
msgstr "Never expires"

#: src/components/settings/ConnectionsSettings.tsx:504
msgid "Never used"
msgstr "Never used"

#: src/components/settings/KeybindingsSettings.tsx:968
msgid "new keybinding"
msgstr "new keybinding"

#: src/components/AddSafeProjectDialog.tsx:148
msgid "New project"
msgstr "New project"

#: src/components/Sidebar.tsx:2237
msgid "New project..."
msgstr "New project..."

#: src/components/CommandPalette.tsx:270
#: src/components/CommandPalette.tsx:292
msgid "new thread"
msgstr "new thread"

#: src/components/ChatView.logic.ts:25
#: src/components/ChatView.tsx:1180
#: src/components/Sidebar.tsx:1384
msgid "New thread"
msgstr "New thread"

#: src/components/CommandPalette.tsx:272
msgid "New thread in <0>{activeProjectTitle}</0>"
msgstr "New thread in <0>{activeProjectTitle}</0>"

#: src/components/CommandPalette.tsx:293
msgid "New thread in..."
msgstr "New thread in..."

#: src/components/Sidebar.tsx:2251
msgid "New thread..."
msgstr "New thread..."

#: src/components/chat/ExpandedImageDialog.tsx:114
msgid "Next image"
msgstr "Next image"

#: src/components/settings/SettingsPanels.tsx:107
msgid "Nightly"
msgstr "Nightly"

#: src/components/PlanSidebar.tsx:133
msgid "No active plan yet."
msgstr "No active plan yet."

#: src/components/NoActiveThreadState.tsx:13
msgid "No active thread"
msgstr "No active thread"

#: src/routes/__root.tsx:251
msgid "No additional error details are available."
msgstr "No additional error details are available."

#: src/components/settings/SettingsPanels.tsx:509
msgid "No archived threads"
msgstr "No archived threads"

#: src/components/DocumentsSidebar.tsx:744
msgid "No created files in this project yet."
msgstr "No created files in this project yet."

#. placeholder {0}: searchQuery.trim()
#: src/components/DocumentsSidebar.tsx:730
msgid "No documents match “{0}”."
msgstr "No documents match “{0}”."

#: src/components/settings/ConnectionsSettings.tsx:1008
#: src/components/settings/ConnectionsSettings.tsx:1014
msgid "No expiry"
msgstr "No expiry"

#: src/components/settings/DiagnosticsSettings.tsx:1149
msgid "No failed spans found."
msgstr "No failed spans found."

#: src/components/settings/KeybindingsSettings.tsx:1293
msgid "No keybindings match your search."
msgstr "No keybindings match your search."

#: src/components/settings/DiagnosticsSettings.tsx:494
#: src/components/settings/DiagnosticsSettings.tsx:993
msgid "No live descendant processes found."
msgstr "No live descendant processes found."

#: src/components/CommandPaletteResults.tsx:36
msgid "No matching actions."
msgstr "No matching actions."

#: src/components/chat/ChatComposer.tsx:627
#: src/components/chat/ComposerCommandMenu.tsx:167
msgid "No matching command."
msgstr "No matching command."

#: src/components/CommandPaletteResults.tsx:37
msgid "No matching commands, projects, or threads."
msgstr "No matching commands, projects, or threads."

#: src/components/chat/ChatComposer.tsx:626
#: src/components/chat/ComposerCommandMenu.tsx:166
msgid "No matching files or folders."
msgstr "No matching files or folders."

#: src/components/chat/DraftProjectChip.tsx:157
msgid "No matching projects."
msgstr "No matching projects."

#: src/components/DocumentsSidebar.tsx:735
msgid "No materials in this project yet."
msgstr "No materials in this project yet."

#: src/components/chat/MessagesTimeline.tsx:1398
msgid "No output"
msgstr "No output"

#: src/components/settings/ConnectionsSettings.tsx:1133
msgid "No pairing links or client sessions."
msgstr "No pairing links or client sessions."

#: src/components/settings/DiagnosticsSettings.tsx:1057
msgid "No process resource samples found for this window."
msgstr "No process resource samples found for this window."

#: src/components/settings/UsageSettings.tsx:100
msgid "No projects yet."
msgstr "No projects yet."

#: src/components/chat/MessagesTimeline.tsx:1443
#~ msgid "No raw details"
#~ msgstr "No raw details"

#: src/components/settings/DiagnosticsSettings.tsx:1179
msgid "No repeated failures found."
msgstr "No repeated failures found."

#: src/components/chat/MessagesTimeline.tsx:1098
#: src/components/chat/MessagesTimeline.tsx:1456
msgid "no rule"
msgstr "no rule"

#: src/components/settings/ConnectionsSettings.tsx:1272
msgid "No saved remote environments"
msgstr "No saved remote environments"

#: src/components/chat/ChatComposer.tsx:623
#: src/components/chat/ComposerCommandMenu.tsx:157
msgid "No skills found. Try / to browse provider commands."
msgstr "No skills found. Try / to browse provider commands."

#: src/components/settings/DiagnosticsSettings.tsx:1209
#: src/components/settings/DiagnosticsSettings.tsx:1315
msgid "No spans found."
msgstr "No spans found."

#: src/components/Sidebar.tsx:609
msgid "No threads yet"
msgstr "No threads yet"

#: src/components/settings/DiagnosticsSettings.tsx:59
msgid "No trace records"
msgstr "No trace records"

#: src/components/SubAgentThreadView.tsx:169
#: src/components/SubAgentThreadView.tsx:175
msgid "No transcript yet"
msgstr "No transcript yet"

#: src/components/settings/DiagnosticsSettings.tsx:1282
msgid "No warnings or errors found."
msgstr "No warnings or errors found."

#: src/components/settings/KeybindingsSettings.tsx:370
#: src/components/settings/KeybindingsSettings.tsx:411
msgid "Not"
msgstr "Not"

#: src/components/settings/ConnectionsSettings.tsx:256
#: src/components/settings/ConnectionsSettings.tsx:718
msgid "Not connected yet."
msgstr "Not connected yet."

#: src/components/chat/MessagesTimeline.tsx:1385
msgid "Not loaded yet"
msgstr "Not loaded yet"

#: src/hooks/useVoiceInput.ts:81
msgid "Nothing was recorded"
msgstr "Nothing was recorded"

#: src/components/settings/UsageSettings.tsx:89
msgid "OCR usage"
msgstr "OCR usage"

#: src/components/chat/CompactComposerControlsMenu.tsx:46
msgid "Off"
msgstr "Off"

#: src/components/chat/CompactComposerControlsMenu.tsx:43
msgid "On"
msgstr "On"

#: src/components/settings/ConnectionsSettings.tsx:497
msgid "One-time"
msgstr "One-time"

#: src/routes/_chat.index.tsx:72
msgid "Open a pairing link or add a reachable backend manually. Your saved environments stay in this browser."
msgstr "Open a pairing link or add a reachable backend manually. Your saved environments stay in this browser."

#: src/components/auth/PairingRouteSurface.tsx:275
msgid "Open app"
msgstr "Open app"

#: src/components/settings/ConnectionsSettings.tsx:439
msgid "Open it in the client you want to pair to this environment."
msgstr "Open it in the client you want to pair to this environment."

#: src/components/CommandPalette.tsx:319
msgid "Open settings"
msgstr "Open settings"

#: src/components/settings/SettingsPanels.tsx:306
msgid "Open the right-side plan and task panel automatically when steps appear."
msgstr "Open the right-side plan and task panel automatically when steps appear."

#: src/components/settings/SettingsPanels.tsx:325
msgid "Open the task panel automatically"
msgstr "Open the task panel automatically"

#: src/components/settings/ConnectionsSettings.tsx:111
msgid "Operate tasks"
msgstr "Operate tasks"

#: src/components/chat/MessagesTimeline.tsx:1375
msgid "Output"
msgstr "Output"

#: src/components/chat/TurnInspectionButton.tsx:113
msgctxt "token usage"
msgid "Output"
msgstr "Output"

#: src/components/DocumentsSidebar.tsx:546
#: src/components/settings/UsageSettings.tsx:114
msgid "Pages"
msgstr "Pages"

#: src/components/settings/UsageSettings.tsx:117
msgid "Paid pages"
msgstr "Paid pages"

#: src/components/settings/ConnectionsSettings.tsx:1738
msgid "Pair another environment to this client."
msgstr "Pair another environment to this client."

#: src/components/auth/PairingRouteSurface.tsx:115
msgid "Pair with this environment"
msgstr "Pair with this environment"

#: src/components/auth/PairingRouteSurface.tsx:241
msgid "Pairing backend"
msgstr "Pairing backend"

#: src/components/settings/ConnectionsSettings.tsx:626
#: src/components/settings/ConnectionsSettings.tsx:1572
msgid "Pairing code"
msgstr "Pairing code"

#: src/components/settings/ConnectionsSettings.tsx:436
msgid "Pairing code copied"
msgstr "Pairing code copied"

#: src/components/auth/PairingRouteSurface.tsx:239
msgid "Pairing failed"
msgstr "Pairing failed"

#: src/components/settings/ConnectionsSettings.tsx:506
#: src/components/settings/ConnectionsSettings.tsx:626
msgid "Pairing link"
msgstr "Pairing link"

#: src/components/settings/ConnectionsSettings.tsx:555
#: src/components/settings/ConnectionsSettings.tsx:658
msgid "Pairing link — scan to open on another device"
msgstr "Pairing link — scan to open on another device"

#: src/components/settings/ConnectionsSettings.tsx:572
msgid "Pairing link scopes"
msgstr "Pairing link scopes"

#: src/components/settings/ConnectionsSettings.tsx:1691
msgid "Pairing links and client-session management require the access:write scope for this backend."
msgstr "Pairing links and client-session management require the access:write scope for this backend."

#: src/components/auth/PairingRouteSurface.tsx:312
#~ msgid "Pairing links can open this page directly, or you can paste the token here."
#~ msgstr "Pairing links can open this page directly, or you can paste the token here."

#: src/components/auth/PairingRouteSurface.tsx:125
msgid "Pairing token"
msgstr "Pairing token"

#: src/components/settings/ConnectionsSettings.tsx:436
msgid "Pairing URL copied"
msgstr "Pairing URL copied"

#: src/components/auth/PairingRouteSurface.tsx:31
msgid "Pairing with this environment"
msgstr "Pairing with this environment"

#: src/components/auth/PairingRouteSurface.tsx:138
#: src/components/auth/PairingRouteSurface.tsx:266
msgid "Pairing..."
msgstr "Pairing..."

#: src/components/settings/DiagnosticsSettings.tsx:1093
msgid "Parse Errors"
msgstr "Parse Errors"

#: src/components/settings/ConnectionsSettings.tsx:1585
msgid "Paste a full pairing URL here to fill both fields automatically."
msgstr "Paste a full pairing URL here to fill both fields automatically."

#: src/components/settings/ConnectionsSettings.tsx:440
msgid "Paste it into another client to finish pairing."
msgstr "Paste it into another client to finish pairing."

#: src/components/Sidebar.tsx:767
msgid "Path copied"
msgstr "Path copied"

#. placeholder {0}: member.cwd
#: src/components/Sidebar.tsx:1112
#: src/components/Sidebar.tsx:1122
#: src/components/Sidebar.tsx:1159
msgid "Path: {0}"
msgstr "Path: {0}"

#: src/components/settings/DiagnosticsSettings.tsx:727
msgid "Peak"
msgstr "Peak"

#: src/components/DocumentsSidebar.tsx:491
msgid "Pending"
msgstr "Pending"

#: src/components/settings/ConnectionsSettings.tsx:880
msgid "Permissions"
msgstr "Permissions"

#: src/components/CommandPalette.tsx:292
msgid "pick"
msgstr "pick"

#: src/components/NoActiveThreadState.tsx:22
msgid "Pick a thread to continue"
msgstr "Pick a thread to continue"

#: src/components/chat/DraftProjectChip.tsx:104
msgid "Pick the project this message is for."
msgstr "Pick the project this message is for."

#: src/components/settings/DiagnosticsSettings.tsx:480
#: src/components/settings/DiagnosticsSettings.tsx:736
msgid "PID"
msgstr "PID"

#: src/components/chat/MessagesTimeline.tsx:940
msgid "Plan"
msgstr "Plan"

#: src/components/chat/MessagesTimeline.tsx:948
msgid "Plan updated"
msgstr "Plan updated"

#: src/components/PlanSidebar.tsx:136
msgid "Plans will appear here when generated."
msgstr "Plans will appear here when generated."

#: src/components/CommandPalette.tsx:318
msgid "preferences"
msgstr "preferences"

#: src/components/settings/KeybindingsSettings.tsx:856
#: src/components/settings/KeybindingsSettings.tsx:1021
msgid "Press shortcut"
msgstr "Press shortcut"

#: src/hooks/useVoiceInput.ts:152
msgid "Press the microphone again to start recording."
msgstr "Press the microphone again to start recording."

#. placeholder {0}: attachment.name
#: src/components/chat/AttachmentsBlock.tsx:138
msgid "Preview {0}"
msgstr "Preview {0}"

#: src/components/chat/ExpandedImageDialog.tsx:80
msgid "Previous image"
msgstr "Previous image"

#: src/components/settings/DiagnosticsSettings.tsx:305
#: src/components/settings/DiagnosticsSettings.tsx:715
msgid "Process"
msgstr "Process"

#: src/components/settings/DiagnosticsSettings.tsx:899
msgid "Process already exited"
msgstr "Process already exited"

#: src/components/settings/DiagnosticsSettings.tsx:1031
msgid "Processes"
msgstr "Processes"

#: src/components/CommandPalette.tsx:292
msgid "project"
msgstr "project"

#: src/components/settings/UsageSettings.tsx:108
msgid "Project"
msgstr "Project"

#: src/components/Sidebar.tsx:1536
msgid "Project API unavailable."
msgstr "Project API unavailable."

#: src/components/Sidebar.tsx:1089
msgid "Project is not empty"
msgstr "Project is not empty"

#: src/components/AddSafeProjectDialog.tsx:156
#: src/components/AddSafeProjectDialog.tsx:157
msgid "Project name"
msgstr "Project name"

#: src/components/chat/DraftProjectChip.tsx:98
msgid "Project not selected"
msgstr "Project not selected"

#: src/components/Sidebar.tsx:1825
#: src/components/Sidebar.tsx:1828
msgid "Project title"
msgstr "Project title"

#: src/components/Sidebar.tsx:1520
msgid "Project title cannot be empty"
msgstr "Project title cannot be empty"

#: src/components/chat/DraftProjectChip.tsx:79
#: src/components/CommandPalette.logic.ts:208
#: src/components/CommandPalette.tsx:296
#: src/components/Sidebar.tsx:2260
msgid "Projects"
msgstr "Projects"

#: src/components/chat/MessagesTimeline.tsx:1506
msgid "Query"
msgstr "Query"

#: src/components/chat/MessagesTimeline.tsx:524
msgid "Question"
msgstr "Question"

#: src/components/chat/MessagesTimeline.tsx:927
msgid "Ran command"
msgstr "Ran command"

#: src/components/settings/InspectSettings.tsx:23
#: src/components/settings/InspectSettings.tsx:29
#~ msgid "Raw step data"
#~ msgstr "Raw step data"

#: src/components/settings/InspectSettings.tsx:23
#: src/components/settings/InspectSettings.tsx:29
#~ msgid "Raw tool calls"
#~ msgstr "Raw tool calls"

#: src/components/chat/MessagesTimeline.tsx:931
msgid "Read file"
msgstr "Read file"

#: src/components/settings/ConnectionsSettings.tsx:893
msgid "Read only"
msgstr "Read only"

#: src/components/settings/ConnectionsSettings.tsx:107
msgid "Read threads, status, diffs, and configuration."
msgstr "Read threads, status, diffs, and configuration."

#: src/components/DocumentsSidebar.tsx:490
msgid "Ready"
msgstr "Ready"

#: src/components/chat/MessagesTimeline.tsx:939
msgid "Reasoning"
msgstr "Reasoning"

#: src/components/settings/CapabilitiesSettings.tsx:260
#: src/components/settings/CapabilitiesSettings.tsx:272
msgid "Reasoning effort"
msgstr "Reasoning effort"

#: src/components/chat/MessagesTimeline.tsx:951
msgid "Reasoning update"
msgstr "Reasoning update"

#: src/components/CommandPalette.logic.ts:262
msgid "Recent Threads"
msgstr "Recent Threads"

#: src/components/ChatView.tsx:574
msgid "Reconnect"
msgstr "Reconnect"

#: src/components/ChatView.tsx:1030
#~ msgid "Reconnect {activeEnvironmentUnavailableLabel} before reverting checkpoints."
#~ msgstr "Reconnect {activeEnvironmentUnavailableLabel} before reverting checkpoints."

#: src/components/WebSocketConnectionSurface.tsx:242
msgid "Reconnect failed"
msgstr "Reconnect failed"

#: src/components/ChatView.tsx:554
msgid "Reconnect this environment before sending messages or running actions."
msgstr "Reconnect this environment before sending messages or running actions."

#. placeholder {0}: getConnectionDisplayName(status)
#: src/components/WebSocketConnectionSurface.tsx:66
msgid "Reconnected to {0}"
msgstr "Reconnected to {0}"

#. placeholder {0}: formatRetryCountdown(status.nextRetryAt, nowMs)
#. placeholder {1}: formatReconnectAttemptLabel(status)
#: src/components/WebSocketConnectionSurface.tsx:435
msgid "Reconnecting in {0}... {1}"
msgstr "Reconnecting in {0}... {1}"

#: src/components/ChatView.tsx:572
msgid "Reconnecting..."
msgstr "Reconnecting..."

#. placeholder {0}: formatReconnectAttemptLabel(status)
#: src/components/WebSocketConnectionSurface.tsx:434
msgid "Reconnecting... {0}"
msgstr "Reconnecting... {0}"

#: src/components/chat/ChatComposer.tsx:1116
msgid "Recording stopped"
msgstr "Recording stopped"

#: src/components/chat/ChatComposer.tsx:1117
msgid "Recordings are limited to 30 minutes."
msgstr "Recordings are limited to 30 minutes."

#: src/components/StaleClientToastCoordinator.tsx:45
msgid "Refresh"
msgstr "Refresh"

#: src/components/DocumentsSidebar.tsx:800
msgid "Refresh documents"
msgstr "Refresh documents"

#: src/components/settings/DiagnosticsSettings.tsx:944
msgid "Refresh process diagnostics"
msgstr "Refresh process diagnostics"

#: src/components/settings/DiagnosticsSettings.tsx:1009
msgid "Refresh resource history"
msgstr "Refresh resource history"

#: src/components/StaleClientToastCoordinator.tsx:42
msgid "Refresh the page to keep {APP_BASE_NAME} working correctly."
msgstr "Refresh the page to keep {APP_BASE_NAME} working correctly."

#: src/components/settings/DiagnosticsSettings.tsx:1069
msgid "Refresh trace diagnostics"
msgstr "Refresh trace diagnostics"

#: src/routes/__root.tsx:205
msgid "Reload app"
msgstr "Reload app"

#: src/components/CommandPalette.tsx:308
#~ msgid "remote"
#~ msgstr "remote"

#: src/components/Sidebar.tsx:305
#: src/components/Sidebar.tsx:471
#: src/components/ThreadStatusIndicators.tsx:139
#: src/components/ThreadStatusIndicators.tsx:151
msgid "Remote"
msgstr "Remote"

#. placeholder {0}: project.remoteEnvironmentLabels.join(", ")
#: src/components/Sidebar.tsx:1756
msgid "Remote environment: {0}"
msgstr "Remote environment: {0}"

#: src/components/settings/ConnectionsSettings.tsx:1697
msgid "Remote environments"
msgstr "Remote environments"

#: src/components/Sidebar.tsx:1746
msgid "Remote project"
msgstr "Remote project"

#: src/components/settings/ConnectionsSettings.tsx:1255
#: src/components/settings/KeybindingsSettings.tsx:926
#: src/components/Sidebar.tsx:1391
msgid "Remove"
msgstr "Remove"

#. placeholder {0}: attachment.name
#: src/components/chat/AttachmentsBlock.tsx:178
msgid "Remove {0}"
msgstr "Remove {0}"

#: src/components/settings/KeybindingsSettings.tsx:384
msgid "Remove condition"
msgstr "Remove condition"

#: src/components/settings/KeybindingsSettings.tsx:548
msgid "Remove group"
msgstr "Remove group"

#: src/components/settings/KeybindingsSettings.tsx:419
msgid "Remove negated group"
msgstr "Remove negated group"

#. placeholder {0}: member.name
#: src/components/Sidebar.tsx:1121
#: src/components/Sidebar.tsx:1158
msgid "Remove project \"{0}\"?"
msgstr "Remove project \"{0}\"?"

#: src/components/settings/ConnectionsSettings.tsx:1253
msgid "Removing…"
msgstr "Removing…"

#: src/components/Sidebar.tsx:1388
msgid "Rename"
msgstr "Rename"

#: src/components/Sidebar.tsx:1814
msgid "Rename project"
msgstr "Rename project"

#: src/components/Sidebar.tsx:1574
msgid "Rename thread"
msgstr "Rename thread"

#: src/components/CommandPalette.tsx:309
#~ msgid "repository"
#~ msgstr "repository"

#: src/environments/primary/auth.ts:197
msgid "Requested scope exceeds the bootstrap credential grant."
msgstr "Requested scope exceeds the bootstrap credential grant."

#: src/environments/primary/auth.ts:196
msgid "Requested token scope is invalid."
msgstr "Requested token scope is invalid."

#: src/components/settings/SettingsPanels.tsx:332
msgid "Require a second click on the inline archive action before a thread is archived."
msgstr "Require a second click on the inline archive action before a thread is archived."

#: src/components/settings/settingsLayout.tsx:108
msgid "Reset {label} to default"
msgstr "Reset {label} to default"

#: src/components/settings/KeybindingsSettings.tsx:921
#: src/components/settings/settingsLayout.tsx:120
msgid "Reset to default"
msgstr "Reset to default"

#: src/components/settings/DiagnosticsSettings.tsx:999
msgid "Resource History"
msgstr "Resource History"

#: src/components/settings/SettingsPanels.tsx:162
msgid "Restore default settings?"
msgstr "Restore default settings?"

#: src/routes/settings.tsx:28
msgid "Restore defaults"
msgstr "Restore defaults"

#: src/components/WebSocketConnectionSurface.tsx:54
msgid "Retries exhausted trying to reconnect"
msgstr "Retries exhausted trying to reconnect"

#: src/components/chat/BasaDocumentDialog.tsx:238
#: src/components/WebSocketConnectionSurface.tsx:403
msgid "Retry"
msgstr "Retry"

#: src/components/WebSocketConnectionSurface.tsx:421
msgid "Retry now"
msgstr "Retry now"

#: src/components/settings/ConnectionsSettings.tsx:495
msgid "Reusable"
msgstr "Reusable"

#: src/components/ChatView.tsx:1043
#~ msgid "Revert this thread to checkpoint {turnCount}?"
#~ msgstr "Revert this thread to checkpoint {turnCount}?"

#: src/components/chat/MessagesTimeline.tsx:409
#: src/components/chat/MessagesTimeline.tsx:416
#~ msgid "Revert to this message"
#~ msgstr "Revert to this message"

#: src/components/settings/ConnectionsSettings.tsx:684
#: src/components/settings/ConnectionsSettings.tsx:775
msgid "Revoke"
msgstr "Revoke"

#: src/components/settings/ConnectionsSettings.tsx:682
#: src/components/settings/ConnectionsSettings.tsx:773
msgid "Revoking…"
msgstr "Revoking…"

#: src/components/settings/DiagnosticsSettings.tsx:580
msgid "Root process {name}"
msgstr "Root process {name}"

#: src/components/chat/MessagesTimeline.tsx:1445
msgid "Rule"
msgstr "Rule"

#: src/components/chat/ChatComposer.tsx:557
msgid "Run provider command"
msgstr "Run provider command"

#: src/components/chat/ChatComposer.tsx:575
msgid "Run provider skill"
msgstr "Run provider skill"

#: src/components/chat/taskStatusLabels.ts:9
msgid "running"
msgstr "running"

#: src/components/chat/MessagesTimeline.tsx:947
msgid "Runtime error"
msgstr "Runtime error"

#: src/components/settings/DiagnosticsSettings.tsx:1022
msgid "Samples"
msgstr "Samples"

#: src/components/settings/KeybindingsSettings.tsx:874
#: src/components/settings/KeybindingsSettings.tsx:1037
#: src/components/Sidebar.tsx:1850
msgid "Save"
msgstr "Save"

#: src/environments/runtime/service.ts:1301
msgid "Saved environment credential expired. Pair it again."
msgstr "Saved environment credential expired. Pair it again."

#: src/environments/runtime/service.ts:1236
msgid "Saved environment is missing its saved credential."
msgstr "Saved environment is missing its saved credential."

#: src/environments/runtime/service.ts:1233
msgid "Saved environment is missing its saved credential. Pair it again."
msgstr "Saved environment is missing its saved credential. Pair it again."

#: src/environments/runtime/service.ts:1459
msgid "Saved environment not found."
msgstr "Saved environment not found."

#: src/components/settings/KeybindingsSettings.tsx:874
#: src/components/settings/KeybindingsSettings.tsx:1037
msgid "Saving"
msgstr "Saving"

#: src/components/chat/timelineAutoScroll.tsx:50
msgid "Scroll to bottom"
msgstr "Scroll to bottom"

#: src/components/Sidebar.tsx:2219
msgid "Search"
msgstr "Search"

#: src/components/CommandPalette.logic.ts:272
msgid "Search commands, projects, and threads..."
msgstr "Search commands, projects, and threads..."

#: src/components/DocumentsSidebar.tsx:821
msgid "Search documents"
msgstr "Search documents"

#: src/components/settings/KeybindingsSettings.tsx:120
#: src/components/settings/KeybindingsSettings.tsx:127
#: src/components/settings/KeybindingsSettings.tsx:153
#: src/components/settings/KeybindingsSettings.tsx:154
msgid "Search keybindings"
msgstr "Search keybindings"

#: src/components/chat/DraftProjectChip.tsx:148
msgid "Search projects..."
msgstr "Search projects..."

#: src/components/CommandPalette.logic.ts:274
msgid "Search..."
msgstr "Search..."

#: src/components/chat/MessagesTimeline.tsx:932
msgid "Searched files"
msgstr "Searched files"

#: src/components/chat/ComposerCommandMenu.tsx:163
msgid "Searching workspace files..."
msgstr "Searching workspace files..."

#: src/components/chat/ComposerCommandMenu.tsx:155
msgid "Searching workspace skills..."
msgstr "Searching workspace skills..."

#: src/components/CommandPalette.tsx:292
msgid "select"
msgstr "select"

#: src/components/CommandPalette.tsx:440
#: src/components/DocumentsSidebar.tsx:883
msgid "Select"
msgstr "Select"

#: src/components/chat/DraftProjectChip.tsx:114
msgid "Select a project"
msgstr "Select a project"

#: src/components/DocumentsSidebar.tsx:498
msgid "Select all files"
msgstr "Select all files"

#: src/components/NoActiveThreadState.tsx:25
msgid "Select an existing thread or create a new one to get started."
msgstr "Select an existing thread or create a new one to get started."

#: src/components/settings/ConnectionsSettings.tsx:930
msgid "Select at least one permission."
msgstr "Select at least one permission."

#: src/components/DocumentsSidebar.tsx:498
msgid "Select file"
msgstr "Select file"

#: src/components/chat/DraftProjectChip.tsx:139
msgid "Select project"
msgstr "Select project"

#: src/components/chat/MessagesTimeline.tsx:281
msgid "Send a message to start the conversation."
msgstr "Send a message to start the conversation."

#: src/components/chat/ChatComposer.tsx:632
#: src/components/chat/ComposerPrimaryActions.tsx:93
msgid "Send message"
msgstr "Send message"

#: src/components/settings/DiagnosticsSettings.tsx:380
msgid "Send SIGINT"
msgstr "Send SIGINT"

#: src/components/settings/DiagnosticsSettings.tsx:397
msgid "Send SIGKILL"
msgstr "Send SIGKILL"

#: src/components/settings/DiagnosticsSettings.tsx:884
msgid "Send SIGKILL to process {pid}? This cannot be handled by the process."
msgstr "Send SIGKILL to process {pid}? This cannot be handled by the process."

#: src/components/chat/ComposerPrimaryActions.tsx:92
msgid "Sending"
msgstr "Sending"

#: src/components/ChatView.tsx:518
msgid "server"
msgstr "server"

#: src/components/settings/DiagnosticsSettings.tsx:966
msgid "Server PID"
msgstr "Server PID"

#: src/components/settings/InspectSettings.tsx:34
#: src/components/settings/InspectSettings.tsx:40
#~ msgid "Service steps"
#~ msgstr "Service steps"

#: src/components/CommandPalette.tsx:318
msgid "settings"
msgstr "settings"

#: src/components/Sidebar.tsx:2108
#: src/routes/settings.tsx:70
msgid "Settings"
msgstr "Settings"

#: src/components/chat/MessagesTimeline.tsx:1326
msgid "Shell command"
msgstr "Shell command"

#: src/components/chat/ChatComposer.tsx:131
#: src/components/chat/CompactComposerControlsMenu.tsx:61
msgid "Show {planSidebarLabel} sidebar"
msgstr "Show {planSidebarLabel} sidebar"

#: src/components/settings/ConnectionsSettings.tsx:620
msgid "Show code"
msgstr "Show code"

#: src/routes/__root.tsx:212
msgid "Show error details"
msgstr "Show error details"

#: src/components/settings/DiagnosticsSettings.tsx:187
msgid "Show full error"
msgstr "Show full error"

#: src/components/chat/MessagesTimeline.tsx:804
#: src/components/settings/DiagnosticsSettings.tsx:1268
msgid "Show full message"
msgstr "Show full message"

#: src/components/chat/MessagesTimeline.tsx:804
#: src/components/settings/DiagnosticsSettings.tsx:187
#: src/components/Sidebar.tsx:673
msgid "Show less"
msgstr "Show less"

#: src/components/settings/ConnectionsSettings.tsx:620
msgid "Show link"
msgstr "Show link"

#: src/components/Sidebar.tsx:655
msgid "Show more"
msgstr "Show more"

#: src/components/settings/ConnectionsSettings.tsx:543
msgid "Show QR code"
msgstr "Show QR code"

#: src/components/chat/MessagesTimeline.tsx:1110
msgid "Show raw details"
msgstr "Show raw details"

#: src/components/WebSocketConnectionSurface.tsx:523
msgid "Show requests"
msgstr "Show requests"

#: src/components/settings/ConnectionsSettings.tsx:453
msgid "Showing the full value instead."
msgstr "Showing the full value instead."

#: src/components/Sidebar.tsx:1931
msgid "Sidebar options"
msgstr "Sidebar options"

#: src/components/DocumentsSidebar.tsx:555
#: src/components/DocumentsSidebar.tsx:624
msgid "Size"
msgstr "Size"

#: src/components/chat/ComposerCommandMenu.tsx:77
#: src/components/chat/ComposerCommandMenu.tsx:151
msgid "Skills"
msgstr "Skills"

#: src/components/settings/DiagnosticsSettings.tsx:1083
msgid "Slow Spans"
msgstr "Slow Spans"

#: src/components/settings/DiagnosticsSettings.tsx:1184
msgid "Slowest Spans"
msgstr "Slowest Spans"

#: src/components/WebSocketConnectionSurface.tsx:527
msgid "Some requests are slow"
msgstr "Some requests are slow"

#: src/components/settings/KeybindingsSettings.tsx:1242
msgid "Some shortcuts may be claimed by the browser before {APP_BASE_NAME} sees them."
msgstr "Some shortcuts may be claimed by the browser before {APP_BASE_NAME} sees them."

#. placeholder {0}: traceDiagnosticsError.message
#: src/components/settings/DiagnosticsSettings.tsx:1112
msgid "Some trace files could not be read, so diagnostics may be incomplete. {0}"
msgstr "Some trace files could not be read, so diagnostics may be incomplete. {0}"

#: src/routes/__root.tsx:196
msgid "Something went wrong."
msgstr "Something went wrong."

#: src/timestampFormat.ts:106
msgid "Soon"
msgstr "Soon"

#: src/components/Sidebar.tsx:1937
msgid "Sort projects"
msgstr "Sort projects"

#: src/components/Sidebar.tsx:1958
msgid "Sort threads"
msgstr "Sort threads"

#: src/components/settings/DiagnosticsSettings.tsx:1129
#: src/components/settings/DiagnosticsSettings.tsx:1157
#: src/components/settings/DiagnosticsSettings.tsx:1187
#: src/components/settings/DiagnosticsSettings.tsx:1238
#: src/components/settings/DiagnosticsSettings.tsx:1290
msgid "Span"
msgstr "Span"

#: src/components/settings/DiagnosticsSettings.tsx:1213
msgid "Span Logs"
msgstr "Span Logs"

#: src/components/settings/DiagnosticsSettings.tsx:1076
msgid "Spans"
msgstr "Spans"

#: src/components/settings/DiagnosticsSettings.tsx:1088
msgid "Spans at or above the configured slow-span threshold."
msgstr "Spans at or above the configured slow-span threshold."

#. placeholder {0}: formatDuration(data.slowSpanThresholdMs)
#: src/components/settings/DiagnosticsSettings.tsx:1087
msgid "Spans with a duration of {0} or longer."
msgstr "Spans with a duration of {0} or longer."

#: src/components/settings/ConnectionsSettings.tsx:901
msgid "Standard"
msgstr "Standard"

#: src/components/settings/ConnectionsSettings.tsx:112
msgid "Start tasks and perform changes in the environment."
msgstr "Start tasks and perform changes in the environment."

#: src/components/chat/MessagesTimeline.tsx:1476
msgid "Started"
msgstr "Started"

#. placeholder {0}: formatConnectionMoment(req.startedAt) ?? req.startedAt
#: src/components/WebSocketConnectionSurface.tsx:110
msgid "Started {0}"
msgstr "Started {0}"

#: src/components/chat/MessagesTimeline.tsx:1471
#: src/components/DocumentsSidebar.tsx:526
#: src/components/settings/KeybindingsSettings.tsx:1265
msgid "Status"
msgstr "Status"

#: src/components/chat/MessagesTimeline.tsx:1371
msgid "Step"
msgstr "Step"

#: src/components/PlanSidebar.tsx:100
msgid "Steps"
msgstr "Steps"

#: src/components/settings/InspectSettings.tsx:35
#~ msgid "Steps meant for developers and provider warnings. Off, they stay hidden as they are for a user."
#~ msgstr "Steps meant for developers and provider warnings. Off, they stay hidden as they are for a user."

#: src/components/chat/ComposerPrimaryActions.tsx:57
msgid "Stop generation"
msgstr "Stop generation"

#: src/components/chat/ComposerVoiceButton.tsx:59
msgid "Stop recording"
msgstr "Stop recording"

#: src/components/chat/ComposerPrimaryActions.tsx:57
msgid "Stop upload"
msgstr "Stop upload"

#: src/components/chat/taskStatusLabels.ts:13
msgid "stopped"
msgstr "stopped"

#: src/components/chat/MessagesTimeline.tsx:937
msgid "Subagent task"
msgstr "Subagent task"

#: src/components/settings/DiagnosticsSettings.tsx:303
msgid "Subprocess"
msgstr "Subprocess"

#: src/components/settings/SettingsPanels.tsx:88
msgid "Switches the hosted app release channel."
msgstr "Switches the hosted app release channel."

#: src/components/settings/SettingsPanels.tsx:47
#: src/components/settings/SettingsPanels.tsx:214
msgid "System"
msgstr "System"

#: src/components/settings/SettingsPanels.tsx:60
msgid "System default"
msgstr "System default"

#: src/components/settings/SettingsPanels.tsx:262
msgid "System default follows your browser or OS clock preference."
msgstr "System default follows your browser or OS clock preference."

#: src/components/chat/ChatComposer.tsx:610
#: src/components/PlanSidebar.tsx:48
msgid "Tasks"
msgstr "Tasks"

#: src/components/settings/CapabilitiesSettings.tsx:153
msgid "Team flag file"
msgstr "Team flag file"

#: src/components/chat/ThreadErrorBanner.tsx:18
msgid "The agent could not complete the request. Contact your administrator if this persists."
msgstr "The agent could not complete the request. Contact your administrator if this persists."

#: src/components/chat/ProviderStatusBanner.tsx:19
msgid "The agent has limited availability"
msgstr "The agent has limited availability"

#: src/components/chat/ProviderStatusBanner.tsx:21
msgid "The agent is not signed in"
msgstr "The agent is not signed in"

#: src/components/chat/ProviderStatusBanner.tsx:22
msgid "The agent is unavailable"
msgstr "The agent is unavailable"

#. placeholder {0}: error.requiredScope
#: src/environments/primary/auth.ts:199
msgid "The authenticated token is missing required scope: {0}."
msgstr "The authenticated token is missing required scope: {0}."

#. placeholder {0}: model.model
#: src/components/settings/CapabilitiesSettings.tsx:219
msgid "The Codex instance does not offer the configured model <0>{0}</0>."
msgstr "The Codex instance does not offer the configured model <0>{0}</0>."

#: src/components/chat/ContextWindowMeter.tsx:128
#~ msgid "The context is compacted automatically when needed."
#~ msgstr "The context is compacted automatically when needed."

#: src/components/chat/BasaDocumentDialog.tsx:206
msgid "The document address is invalid."
msgstr "The document address is invalid."

#: src/components/settings/CapabilitiesSettings.tsx:122
msgid "The feature flag file was not updated."
msgstr "The feature flag file was not updated."

#: src/components/settings/KeybindingsSettings.tsx:1169
msgid "The keybinding was not removed."
msgstr "The keybinding was not removed."

#: src/components/settings/KeybindingsSettings.tsx:1149
msgid "The keybinding was not saved."
msgstr "The keybinding was not saved."

#: src/components/chat/BasaDocumentDialog.tsx:202
msgid "The legal database is temporarily unavailable. Try again later."
msgstr "The legal database is temporarily unavailable. Try again later."

#: src/components/settings/ConnectionsSettings.tsx:1025
msgid "The link and its devices stay valid until the link is revoked."
msgstr "The link and its devices stay valid until the link is revoked."

#. placeholder {0}: accessTimestampFormatter.format( new Date(Date.now() + pairingTtlDays * SECONDS_PER_DAY * 1000), )
#: src/components/settings/ConnectionsSettings.tsx:1026
msgid "The link and its devices will expire on {0}."
msgstr "The link and its devices will expire on {0}."

#: src/components/settings/KeybindingsSettings.tsx:286
msgid "The most recent matching binding wins when both conditions can apply."
msgstr "The most recent matching binding wins when both conditions can apply."

#: src/components/settings/DiagnosticsSettings.tsx:900
msgid "The process is not a child of the {APP_SERVER_NAME}. It might already have exited."
msgstr "The process is not a child of the {APP_SERVER_NAME}. It might already have exited."

#: src/components/chat/DraftProjectChip.tsx:103
msgid "The project for this draft is unavailable. Pick a project to send."
msgstr "The project for this draft is unavailable. Pick a project to send."

#: src/components/settings/CapabilitiesSettings.tsx:92
msgid "The server did not answer."
msgstr "The server did not answer."

#: src/components/settings/CapabilitiesSettings.tsx:157
msgid "The team flag file is invalid; the last valid values stay in force until it is fixed or the next change here rewrites it."
msgstr "The team flag file is invalid; the last valid values stay in force until it is fixed or the next change here rewrites it."

#: src/components/settings/CapabilitiesSettings.tsx:211
msgid "The team model value is invalid; the image value applies."
msgstr "The team model value is invalid; the image value applies."

#: src/components/settings/CapabilitiesSettings.tsx:188
msgid "The team value is invalid; the image value applies."
msgstr "The team value is invalid; the image value applies."

#: src/components/settings/SettingsPanels.tsx:199
msgid "theme"
msgstr "theme"

#: src/components/settings/SettingsPanels.tsx:127
#: src/components/settings/SettingsPanels.tsx:195
msgid "Theme"
msgstr "Theme"

#: src/components/settings/SettingsPanels.tsx:211
msgid "Theme preference"
msgstr "Theme preference"

#: src/components/chat/MessagesTimeline.tsx:600
msgid "Thinking"
msgstr "Thinking"

#: src/components/chat/MessagesTimeline.tsx:565
#~ msgid "Thinking about the next step"
#~ msgstr "Thinking about the next step"

#: src/components/Sidebar.tsx:1118
msgid "This action cannot be undone."
msgstr "This action cannot be undone."

#: src/components/settings/ConnectionsSettings.tsx:1628
msgid "This backend is already configured for remote access. Network exposure changes must be made where the server is launched."
msgstr "This backend is already configured for remote access. Network exposure changes must be made where the server is launched."

#: src/components/settings/ConnectionsSettings.tsx:1629
msgid "This backend is only reachable on this machine. Restart it with a non-loopback host to enable remote pairing."
msgstr "This backend is only reachable on this machine. Restart it with a non-loopback host to enable remote pairing."

#: src/components/settings/ConnectionsSettings.tsx:934
msgid "This client can create or revoke access for other devices."
msgstr "This client can create or revoke access for other devices."

#: src/components/settings/ConnectionsSettings.tsx:750
#: src/environmentOptions.ts:32
msgid "This device"
msgstr "This device"

#: src/components/settings/ConnectionsSettings.tsx:1659
#: src/components/settings/ConnectionsSettings.tsx:1688
msgid "This environment"
msgstr "This environment"

#: src/components/auth/PairingRouteSurface.tsx:183
msgid "This one-time pairing token was already submitted. Request a new pairing link."
msgstr "This one-time pairing token was already submitted. Request a new pairing link."

#: src/environments/primary/auth.ts:201
msgid "This operation is not allowed for the current session."
msgstr "This operation is not allowed for the current session."

#: src/components/StaleClientToastCoordinator.tsx:41
msgid "This page is out of date"
msgstr "This page is out of date"

#: src/environments/primary/auth.ts:192
msgid "This pairing link has already been used on all of its devices. Request a new one."
msgstr "This pairing link has already been used on all of its devices. Request a new one."

#: src/components/auth/PairingRouteSurface.tsx:165
#: src/components/auth/PairingRouteSurface.tsx:176
msgid "This pairing link is missing its backend host or token."
msgstr "This pairing link is missing its backend host or token."

#: src/components/Sidebar.tsx:1285
msgid "This permanently clears conversation history for these threads."
msgstr "This permanently clears conversation history for these threads."

#: src/components/Sidebar.tsx:1661
msgid "This permanently clears conversation history for this thread."
msgstr "This permanently clears conversation history for this thread."

#: src/components/Sidebar.tsx:1116
msgid "This permanently clears conversation history for those threads."
msgstr "This permanently clears conversation history for those threads."

#: src/components/Sidebar.tsx:1117
#: src/components/Sidebar.tsx:1126
#: src/components/Sidebar.tsx:1161
msgid "This removes only this project entry."
msgstr "This removes only this project entry."

#: src/components/SubAgentListView.tsx:56
msgid "This thread has not started any agents yet"
msgstr "This thread has not started any agents yet"

#: src/components/ChatView.tsx:1044
#~ msgid "This will discard newer messages and turn diffs in this thread."
#~ msgstr "This will discard newer messages and turn diffs in this thread."

#: src/components/settings/SettingsPanels.tsx:162
msgid "This will reset: {changedList}."
msgstr "This will reset: {changedList}."

#: src/components/Sidebar.tsx:747
msgid "Thread ID copied"
msgstr "Thread ID copied"

#: src/components/Sidebar.tsx:1471
msgid "Thread title cannot be empty"
msgstr "Thread title cannot be empty"

#: src/components/settings/KeybindingsSettings.logic.ts:290
msgid "Thread: Jump {slot}"
msgstr "Thread: Jump {slot}"

#: src/components/settings/KeybindingsSettings.logic.ts:269
msgid "Thread: Next"
msgstr "Thread: Next"

#: src/components/settings/KeybindingsSettings.logic.ts:267
msgid "Thread: Previous"
msgstr "Thread: Previous"

#: src/components/CommandPalette.logic.ts:215
msgid "Threads"
msgstr "Threads"

#: src/components/settings/DiagnosticsSettings.tsx:1232
msgid "Time"
msgstr "Time"

#: src/components/settings/SettingsPanels.tsx:266
msgid "time format"
msgstr "time format"

#: src/components/settings/SettingsPanels.tsx:130
#: src/components/settings/SettingsPanels.tsx:261
msgid "Time format"
msgstr "Time format"

#: src/environments/primary/auth.ts:250
msgid "Timed out waiting for authenticated session after bootstrap."
msgstr "Timed out waiting for authenticated session after bootstrap."

#: src/components/settings/SettingsPanels.tsx:284
msgid "Timestamp format"
msgstr "Timestamp format"

#: src/components/settings/UsageSettings.tsx:120
msgid "Tokens, M"
msgstr "Tokens, M"

#: src/environments/primary/auth.ts:190
msgid "Too many pairing attempts. Wait a few minutes and try again."
msgstr "Too many pairing attempts. Wait a few minutes and try again."

#: src/components/chat/MessagesTimeline.tsx:938
#: src/components/chat/MessagesTimeline.tsx:1461
#: src/components/chat/MessagesTimeline.tsx:1467
msgid "Tool"
msgstr "Tool"

#: src/components/chat/MessagesTimeline.tsx:936
msgid "Tool call"
msgstr "Tool call"

#: src/components/chat/MessagesTimeline.tsx:955
msgid "Tool updated"
msgstr "Tool updated"

#: src/components/settings/DiagnosticsSettings.tsx:1287
msgid "Top Span Names"
msgstr "Top Span Names"

#: src/components/settings/UsageSettings.tsx:155
msgid "Total"
msgstr "Total"

#: src/components/DocumentsSidebar.tsx:710
msgid "Total {total}"
msgstr "Total {total}"

#: src/components/settings/DiagnosticsSettings.tsx:958
msgid "Total CPU across live child processes of the current server process."
msgstr "Total CPU across live child processes of the current server process."

#: src/components/chat/ContextWindowMeter.tsx:119
#~ msgid "Total processed"
#~ msgstr "Total processed"

#: src/components/settings/DiagnosticsSettings.tsx:963
msgid "Total resident memory across live child processes of the current server process."
msgstr "Total resident memory across live child processes of the current server process."

#: src/components/settings/DiagnosticsSettings.tsx:1187
#: src/components/settings/DiagnosticsSettings.tsx:1244
msgid "Trace"
msgstr "Trace"

#: src/components/settings/DiagnosticsSettings.tsx:1063
msgid "Trace Diagnostics"
msgstr "Trace Diagnostics"

#: src/components/chat/ComposerVoiceRecordingBar.tsx:48
msgid "Transcribing"
msgstr "Transcribing"

#: src/components/auth/PairingRouteSurface.tsx:270
#: src/routes/__root.tsx:202
msgid "Try again"
msgstr "Try again"

#: src/components/chat/ChatComposer.tsx:1119
msgid "Try again."
msgstr "Try again."

#: src/components/chat/TurnInspectionButton.tsx:67
msgid "Turn details"
msgstr "Turn details"

#: src/components/chat/MessagesTimeline.tsx:1443
#: src/components/settings/DiagnosticsSettings.tsx:483
msgid "Type"
msgstr "Type"

#: src/components/settings/CapabilitiesSettings.tsx:91
msgid "Unable to load capabilities"
msgstr "Unable to load capabilities"

#: src/environments/runtime/service.ts:1538
msgid "Unable to persist saved environment credentials."
msgstr "Unable to persist saved environment credentials."

#: src/components/settings/KeybindingsSettings.tsx:1167
msgid "Unable to remove keybinding"
msgstr "Unable to remove keybinding"

#: src/environments/runtime/service.ts:1176
msgid "Unable to resolve the primary environment."
msgstr "Unable to resolve the primary environment."

#: src/components/WebSocketConnectionSurface.tsx:244
msgid "Unable to restart the WebSocket."
msgstr "Unable to restart the WebSocket."

#: src/components/CommandPalette.tsx:363
msgid "Unable to run command"
msgstr "Unable to run command"

#: src/components/settings/KeybindingsSettings.tsx:1148
msgid "Unable to save keybinding"
msgstr "Unable to save keybinding"

#: src/components/settings/CapabilitiesSettings.tsx:120
msgid "Unable to update capability"
msgstr "Unable to update capability"

#: src/components/settings/SettingsPanels.tsx:463
#: src/components/settings/SettingsPanels.tsx:570
msgid "Unarchive"
msgstr "Unarchive"

#: src/components/settings/KeybindingsSettings.tsx:856
#: src/components/settings/KeybindingsSettings.tsx:1021
msgid "Unassigned"
msgstr "Unassigned"

#: src/components/Sidebar.tsx:1583
msgid "Unblock chat"
msgstr "Unblock chat"

#. placeholder {0}: identifiers[0]
#: src/components/settings/KeybindingsSettings.tsx:235
msgid "Unknown condition: {0}"
msgstr "Unknown condition: {0}"

#. placeholder {0}: identifiers.join(", ")
#: src/components/settings/KeybindingsSettings.tsx:236
msgid "Unknown conditions: {0}"
msgstr "Unknown conditions: {0}"

#: src/components/Sidebar.tsx:1136
#: src/components/Sidebar.tsx:1171
msgid "Unknown error removing project."
msgstr "Unknown error removing project."

#: src/components/DocumentsSidebar.tsx:493
msgid "Unsupported"
msgstr "Unsupported"

#. placeholder {0}: pairingLink.maxUses
#: src/components/settings/ConnectionsSettings.tsx:498
msgid "Up to {0} devices"
msgstr "Up to {0} devices"

#: src/components/Sidebar.tsx:1819
msgid "Update the project title."
msgstr "Update the project title."

#. placeholder {0}: projectRenameTarget.cwd
#: src/components/Sidebar.tsx:1818
msgid "Update the title for {0}."
msgstr "Update the title for {0}."

#: src/components/settings/SettingsPanels.tsx:87
#: src/components/settings/SettingsPanels.tsx:99
msgid "Update track"
msgstr "Update track"

#: src/components/ChatView.logic.ts:158
msgid "Uploading {currentFile}/{totalFiles} files · {percent}%"
msgstr "Uploading {currentFile}/{totalFiles} files · {percent}%"

#: src/components/ChatView.logic.ts:160
msgid "Uploading… {percent}%"
msgstr "Uploading… {percent}%"

#: src/components/settings/settingsNavItems.ts:34
msgid "Usage"
msgstr "Usage"

#. placeholder {0}: pairingLink.useCount
#. placeholder {1}: pairingLink.maxUses
#: src/components/settings/ConnectionsSettings.tsx:502
msgid "Used {0} of {1}"
msgstr "Used {0} of {1}"

#. placeholder {0}: pairingLink.useCount
#: src/components/settings/ConnectionsSettings.tsx:501
msgid "Used {0}×"
msgstr "Used {0}×"

#: src/components/settings/CapabilitiesSettings.tsx:168
msgid "User capabilities"
msgstr "User capabilities"

#: src/components/chat/MessagesTimeline.tsx:949
msgid "User input requested"
msgstr "User input requested"

#: src/components/chat/MessagesTimeline.tsx:950
msgid "User input submitted"
msgstr "User input submitted"

#: src/components/chat/UserMessageRail.tsx:166
msgid "User messages"
msgstr "User messages"

#: src/components/auth/PairingRouteSurface.tsx:34
msgid "Validating the pairing link and preparing your session."
msgstr "Validating the pairing link and preparing your session."

#: src/components/settings/InspectSettings.tsx:23
#: src/components/settings/InspectSettings.tsx:29
msgid "Verbose output"
msgstr "Verbose output"

#: src/components/auth/PairingRouteSurface.tsx:256
msgid "Verify the backend is reachable from this browser, supports CORS for hosted clients, and is served over HTTPS when opening this page from HTTPS."
msgstr "Verify the backend is reachable from this browser, supports CORS for hosted clients, and is served over HTTPS when opening this page from HTTPS."

#: src/components/settings/SettingsPanels.tsx:69
msgid "Version"
msgstr "Version"

#: src/components/settings/ConnectionsSettings.tsx:1662
msgid "Version drift"
msgstr "Version drift"

#. placeholder {0}: versionMismatch.clientVersion
#. placeholder {1}: versionMismatch.serverVersion
#: src/components/settings/ConnectionsSettings.tsx:1218
msgid "Version drift: client {0}, server {1}."
msgstr "Version drift: client {0}, server {1}."

#: src/versionSkew.ts:49
msgid "Version mismatch. Try syncing the client and server to the same {APP_BASE_NAME} version."
msgstr "Version mismatch. Try syncing the client and server to the same {APP_BASE_NAME} version."

#: src/components/settings/ConnectionsSettings.tsx:121
msgid "View access"
msgstr "View access"

#: src/components/settings/ConnectionsSettings.tsx:106
msgid "View environment"
msgstr "View environment"

#: src/components/Sidebar.tsx:1983
#: src/components/Sidebar.tsx:1998
msgid "Visible thread count"
msgstr "Visible thread count"

#: src/components/settings/SettingsPanels.tsx:133
#: src/components/Sidebar.tsx:1979
msgid "Visible threads"
msgstr "Visible threads"

#: src/components/chat/ComposerVoiceButton.tsx:73
#: src/components/chat/ComposerVoiceButton.tsx:88
#: src/components/settings/CapabilitiesSettings.tsx:49
msgid "Voice input"
msgstr "Voice input"

#: src/components/chat/ComposerVoiceButton.tsx:72
msgid "Voice input is not supported in this browser"
msgstr "Voice input is not supported in this browser"

#: src/components/chat/MessagesTimeline.tsx:607
msgid "Waiting for helpers"
msgstr "Waiting for helpers"

#: src/components/chat/MessagesTimeline.tsx:933
#: src/components/chat/MessagesTimeline.tsx:1330
msgid "Web search"
msgstr "Web search"

#: src/components/settings/KeybindingsSettings.tsx:641
#: src/components/settings/KeybindingsSettings.tsx:1262
msgid "When"
msgstr "When"

#: src/components/settings/KeybindingsSettings.tsx:675
msgid "When expression"
msgstr "When expression"

#: src/components/settings/ConnectionsSettings.tsx:990
msgid "When it ends, the link and every device paired with it stop working."
msgstr "When it ends, the link and every device paired with it stop working."

#: src/components/chat/MessagesTimeline.tsx:441
msgid "Work log"
msgstr "Work log"

#: src/components/chat/MessagesTimeline.tsx:441
msgid "Worked for {elapsed}"
msgstr "Worked for {elapsed}"

#: src/components/chat/taskStatusLabels.ts:10
msgid "working"
msgstr "working"

#: src/components/Sidebar.logic.ts:36
msgid "Working"
msgstr "Working"

#: src/components/chat/MessagesTimeline.tsx:671
msgid "Working for <0/>"
msgstr "Working for <0/>"

#: src/components/chat/MessagesTimeline.tsx:675
msgid "Working..."
msgstr "Working..."

#: src/components/ChatMarkdown.tsx:504
msgid "Wrap lines"
msgstr "Wrap lines"

#: src/components/settings/ConnectionsSettings.tsx:116
msgid "Write reviews"
msgstr "Write reviews"

#: src/components/chat/ChatComposer.tsx:1262
msgid "You can attach up to {PROVIDER_SEND_TURN_MAX_ATTACHMENTS} files per message."
msgstr "You can attach up to {PROVIDER_SEND_TURN_MAX_ATTACHMENTS} files per message."

#: src/components/chat/BasaDocumentDialog.tsx:204
msgid "Your session has expired. Reload the page."
msgstr "Your session has expired. Reload the page."

#: src/components/auth/PairingRouteSurface.tsx:133
msgid "Your token"
msgstr "Your token"

#: src/components/auth/PairingRouteSurface.tsx:133
msgid "Your token, e.g. 7K9M2P4R8T6W"
msgstr "Your token, e.g. 7K9M2P4R8T6W"
